<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />
    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <confirmPopup
      v-if="popuplessonDelete == true"
      :title="titlepass"
      @cancelClick="popuplessonDelete = false"
      @confirmClick="deleteLesson(idpass)"
    />
    <confirmPopup
      v-if="popupsectionDelete == true"
      :title="titlepass"
      @cancelClick="popupsectionDelete = false"
      @confirmClick="deleteSection(idpass)"
    />

    <confirmPopup
      v-if="popupwindowquestiondelete != null"
      :title="titlepass"
      @cancelClick="popupwindowquestiondelete = null"
      @confirmClick="removeQuestion(popupwindowquestiondelete)"
    />

    <div class="py-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>
          <div
            class="rounded-3xl pt-10 px-3 md:px-10 pb-2 heightfix bg-white overflow-y-auto"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
          >
            <div class="flex justify-between gap-2">
              <button
                @click="$router.go(-1)"
                class="cursor-pointer bg-blues text-white hover:bg-[#18469d] px-4 py-1.5 text-xs font-bold rounded-2xl"
              >
                Back
              </button>

              <router-link
                :to="{
                  name: 'AdminCoursePreview',
                  params: { course_id: course_id },
                }"
                class="cursor-pointer bg-blues text-white px-4 py-1.5 text-xs font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-600"
              >
                Preview
              </router-link>
            </div>

            <div class="flex items-center justify-center">
              <!-- <div class="hidden lg:flex"></div> -->
              <div>
                <h1 class="py-2 text-xl text-center font-bold text-blues">
                  <span v-if="$route.query.title">{{
                    $route.query.title
                  }}</span>
                  <span v-else>Update Course</span>
                </h1>
              </div>
            </div>

            <div
              class="mt-10 flex items-center justify-center rounded-lg cursor-pointer gap-2 px-4 py-5 border border-blues hover:bg-gray-100"
              @click="popUpsection = true"
            >
              <img src="@/assets/newd/icon1.svg" alt />
              <p class="text-blues text-sm">Slm Module</p>
            </div>
            <div
              v-if="loading"
              class="flex items-center justify-center h-[calc(100vh-350px)]"
            >
              <img src="@/assets/newd/loading.gif" alt="Loading" />
            </div>
            <!-- unit loop section  -->
            <div v-else class="mt-10 pb-10 flex flex-col gap-10">
              <draggable
                v-model="sectionInfo.data"
                @change="onSecReorder"
                class="flex flex-col gap-10"
              >
                <div v-for="section in sectionInfo.data" class :key="section">
                  <div
                    class="flex items-center justify-between border bg-blues group hover:bg-[#3aa0dd] rounded-lg px-6 py-5 cursor-pointer"
                    @click="courseSectionToggle(section.id)"
                  >
                    <div
                      class="text-white w-[80%] md:w-auto font-semibold flex gap-3"
                    >
                      <div
                        class="hidden md:block w-[15px] h-[18px] flex justify-center mx-auto"
                      >
                        <div
                          class="hidden group-hover:inline-flex items-center justify-center rounded cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            class="w-5 h-5 text-black"
                          >
                            <circle cx="5" cy="5" r="1.5" />
                            <circle cx="12" cy="5" r="1.5" />
                            <circle cx="5" cy="12" r="1.5" />
                            <circle cx="12" cy="12" r="1.5" />

                            <circle cx="5" cy="19" r="1.5" />
                            <circle cx="12" cy="19" r="1.5" />
                          </svg>
                        </div>
                      </div>
                      <p v-if="section.file_type == 'video'">🎥</p>
                      <p v-if="section.file_type == 'download'">⬇️</p>
                      <p v-if="section.file_type == 'document'">📄</p>
                      <p v-if="section.file_type == 'pdf'">📕</p>
                      <p v-if="section.file_type == 'word'">📘</p>
                      <p v-if="section.file_type == 'general'">⚫</p>
                      {{ section.title.slice(0, 100) }}
                      <p
                        v-if="section.title.length > 100"
                        class="text-blues text-sm mt-1 font-semibold"
                      >
                        ...More
                      </p>
                    </div>

                    <div
                      class="relative dropdown-container flex gap-3 items-center"
                    >
                      <div class="relative group" v-if="section.is_publish">
                        <div
                          class="relative inline-flex items-center px-3 py-1.5 text-white text-xs font-medium tracking-wide leading-snug"
                        >
                          <svg
                            class="w-3.5 h-3.5 mr-1.5 text-emerald-300"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            stroke-width="2.5"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Publish
                        </div>
                      </div>

                      <div class="relative group" v-else>
                        <div
                          class="relative inline-flex items-center px-3 py-1.5 text-white text-xs font-medium tracking-wide leading-snug"
                        >
                          <svg
                            class="w-3.5 h-3.5 mr-1.5 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                          </svg>
                          UnPublish
                        </div>
                      </div>
                      <div
                        @click.stop="addOperation(section.id)"
                        class="cursor-pointer w-full h-full"
                      >
                        <!-- <img
                        src="@/assets/more.png"
                        class="w-10 h-10 md:w-6 md:h-6 object-contain cursor-pointer"
                        alt
                      /> -->
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="#e3e3e3"
                        >
                          <path
                            d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
                          />
                        </svg>
                      </div>
                      <div
                        v-if="activeOperationMenu == section.id"
                        class="absolute top-10 w-[160px] z-30 bg-white rounded-xl shadow-lg right-0 py-1"
                        style="box-shadow: 0px 2px 20px 0px #00000040"
                      >
                        <div
                          class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                          @click.stop="
                            (popUpLesson = true), (selectUnitId = section.id)
                          "
                        >
                          <img src="@/assets/newd/icon1.svg" class="w-5" alt />
                          <p class="text-blues text-sm">Add Slm Unit</p>
                        </div>

                        <div
                          class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                          @click.stop="
                            (popUpQuiz = true), (selectUnitId = section.id)
                          "
                        >
                          <img src="@/assets/newd/icon1.svg" class="w-5" alt />
                          <p class="text-blues text-sm">Add Quiz</p>
                        </div>

                        <div
                          class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                          @click.stop="
                            sectionval = section;
                            popUpsectionUpdate = true;
                          "
                        >
                          <img src="@/assets/newd/icon2.svg" class="w-5" alt />
                          <p class="text-greens text-sm">Edit</p>
                        </div>
                        <div
                          class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                          @click.stop="
                            titlepass = section.title;
                            popupsectionDelete = true;
                            idpass = section.id;
                          "
                        >
                          <img src="@/assets/newd/icon3.svg" class="w-5" alt />
                          <p class="text-[#F36540] text-sm">Delete</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- lessoninfo!=null -->
                  <!-- activeCourseMenu === section.id  -->

                  <div v-if="activeCourseMenu.includes(section.id)">
                    <div
                      v-if="lessonloading"
                      class="text-center py-5 text-gray-500 font-semibold"
                    >
                      Loading...
                    </div>
                    <draggable
                      v-else-if="
                        lessonsBySection[section.id] &&
                        lessonsBySection[section.id].length &&
                        !lessonloading
                      "
                      class="dragArea list-group w-full"
                      :list="lessonsBySection[section.id]"
                      :group="'lessons'"
                      @change="(evt) => onReorder(section.id, evt)"
                    >
                      <!-- <pre>{{ lessonsBySection }}</pre> -->
                      <div
                        v-for="lesson in lessonsBySection[section.id]"
                        :key="lesson.id"
                      >
                        <div
                          v-if="section.id == lesson.section_id"
                          class="bg-gray-200 rounded-lg my-3 justify-between relative dropdown-container group"
                        >
                          <div
                            class="px-6 py-5 flex items-center justify-between cursor-pointer"
                          >
                            <div class="flex gap-3 items-center">
                              <!-- 3x3 Dots Icon -->
                              <div
                                class="hidden md:block w-[15px] h-[18px] flex justify-center mx-auto"
                              >
                                <div
                                  class="hidden group-hover:inline-flex items-center justify-center rounded cursor-pointer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                    class="w-5 h-5 text-black"
                                  >
                                    <circle cx="5" cy="5" r="1.5" />
                                    <circle cx="12" cy="5" r="1.5" />
                                    <circle cx="5" cy="12" r="1.5" />
                                    <circle cx="12" cy="12" r="1.5" />

                                    <circle cx="5" cy="19" r="1.5" />
                                    <circle cx="12" cy="19" r="1.5" />
                                  </svg>
                                </div>
                              </div>

                              <p v-if="lesson.file_type == 'video'">🎥</p>
                              <p v-if="lesson.file_type == 'download'">⬇️</p>
                              <p v-if="lesson.file_type == 'document'">📄</p>
                              <p v-if="lesson.file_type == 'pdf'">📕</p>
                              <p v-if="lesson.file_type == 'word'">📘</p>
                              <p v-if="lesson.file_type == 'general'">⚫</p>

                              <p
                                class="text-sm font-semibold text-black cursor-pointer"
                              >
                                {{ lesson.title }}
                              </p>
                            </div>
                            <!-- <img
                            src="@/assets/newd/3dot.png"
                            alt
                            class="px-4 cursor-pointer"
                          /> -->

                            <div @click="addLessonOperation(lesson.id)">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24px"
                                viewBox="0 -960 960 960"
                                width="24px"
                                fill="#000000"
                              >
                                <path
                                  d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
                                />
                              </svg>
                            </div>
                          </div>

                          <div
                            v-if="activeLessonOperationMenu == lesson.id"
                            class="absolute top-10 w-[160px] z-30 bg-white rounded-xl shadow-lg right-0 py-1"
                            style="box-shadow: 0px 2px 20px 0px #00000040"
                          >
                            <div
                              v-if="lesson.lesson_or_quiz == 'lesson'"
                              class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                              @click="
                                updateVale(lesson);
                                lessonVal = lesson;
                                popUp = true;
                                descriptionUpdate = lesson.content;
                              "
                            >
                              <img
                                src="@/assets/newd/icon2.svg"
                                class="w-5"
                                alt
                              />
                              <p class="text-greens text-sm">Edit Slm Unit</p>
                            </div>

                            <div
                              v-if="lesson.lesson_or_quiz == 'quiz'"
                              class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                              @click="
                                lesson.quizzes?.[0]?.quiz?.id &&
                                  getupdateValues(lesson.quizzes[0].quiz.id);
                                popUpupdateQuiz = true;
                              "
                            >
                              <img
                                src="@/assets/newd/icon2.svg"
                                class="w-5"
                                alt
                              />
                              <p class="text-greens text-sm">Edit Quiz</p>
                            </div>

                            <!-- <p v-if="lesson.quizzes.length == 0" class="text-black">Lesson</p>
                        <p v-if="lesson.quizzes.length != 0" class="text-black">Quiz</p> -->

                            <div
                              class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                              @click="
                                titlepass = lesson.title;
                                popuplessonDelete = true;
                                idpass = lesson.id;
                              "
                            >
                              <img
                                src="@/assets/newd/icon3.svg"
                                class="w-5"
                                alt
                              />
                              <p class="text-[#F36540] text-sm">Delete</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </draggable>
                    <div v-else class="text-gray-500 text-center py-5">
                      No lessons found.
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- update unit  -->
    <div
      v-if="popUpsectionUpdate"
      @click.self="popUpsectionUpdate = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center p-4"
    >
      <div
        class="w-full max-w-lg sm:max-w-md md:max-w-lg lg:max-w-xl bg-white rounded-xl p-6 sm:p-8 md:p-10 overflow-y-auto max-h-[80vh]"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-lg sm:text-xl font-bold text-blues">
            Update Slm Module
          </h3>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt
            @click="popUpsectionUpdate = false"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col p-4 sm:p-6 relative border border-gray-100 rounded-2xl"
        >
          <form
            ref="addSection"
            @submit.prevent="updatesection(sectionval)"
            class="flex flex-col gap-4 text-xs sm:text-sm md:text-base h-full"
          >
            <div class="flex flex-col gap-2 w-full">
              <label for="title" class="text-left flex gap-2 items-center"
                >Title <span class="text-red-500">*</span></label
              >
              <input
                id="title"
                v-model="sectionval.title"
                type="text"
                class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                required
              />
            </div>
            <div class="flex flex-col gap-2 w-full">
              <label for="ordering" class="text-left flex gap-2 items-center"
                >Order :<span class="text-red-500">*</span></label
              >
              <input
                id="ordering"
                v-model="sectionval.orderby"
                type="text"
                placeholder="e.g. 1"
                inputmode="numeric"
                @input="
                  ($event) =>
                    (sectionval.orderby = $event.target.value.replace(
                      /\D/g,
                      '',
                    ))
                "
                class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div>
            <!-- <div class="flex flex-col gap-2 w-full">
                  <label for="rbt_levels" class="text-left flex gap-2 items-center">RBT Levels <span class="text-red-500">*</span></label>
                  <input
                    id="rbt_levels"
                    type="text"
                    v-model="sectionval.rbt_levels"
                    class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    required
                  />
                </div> -->

            <!-- <div class="flex flex-col gap-2 w-full hidden">
              <label for="duration" class="text-left flex gap-2 items-center"
                >Duration <span class="text-red-500">*</span></label
              >
              <input
                id="duration"
                type="text"
                v-model="sectionval.duration"
                class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div> -->
            <div class="flex flex-col gap-3">
              <label for="icon" class="text-sm">Icon </label>
              <select
                name="icon"
                id="icon"
                class="bg-gray-50 border-gray-300 rounded-md p-3 w-full"
                v-model="sectionval.file_type"
              >
                <option value="" selected>Select</option>
                <option value="video">video 🎥</option>
                <option value="download">download ⬇️</option>
                <option value="document">document 📄</option>
                <option value="pdf">pdf 📕</option>
                <option value="word">word 📘</option>
                <option value="general">general ⚫</option>
              </select>
            </div>
            <div class="flex flex-row gap-3">
              <input
                id="feedback"
                v-model="sectionval.feedback"
                :checked="sectionval.feedback"
                type="checkbox"
              />
              <label for="feedback" class="text-sm font-medium">
                Enable Feedback
              </label>
            </div>
            <div class="flex flex-row gap-3">
              <input
                id="module_lock"
                v-model="sectionval.locking_status"
                :checked="sectionval.locking_status"
                type="checkbox"
              />
              <label for="module_lock" class="text-sm font-medium">
                Enable Module Locking System
              </label>
            </div>
            <div class="flex flex-row gap-3">
              <input
                id="Publish"
                v-model="sectionval.is_publish"
                :checked="sectionval.is_publish"
                type="checkbox"
              />
              <label for="Publish" class="text-sm font-medium"> Publish </label>
            </div>
            <div class="flex justify-end items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-6 py-2"
              >
                Update
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>

            <!-- <div class="flex justify-end pb-4 mt-3">
              <button
                type="submit"
                class="text-white border border-blues rounded-lg text-sm px-10 py-2 bg-blues"
              >
                Update
              </button>
            </div> -->
          </form>
        </div>
      </div>
    </div>
    <!-- add unit  -->
    <div
      v-if="popUpsection"
      @click.self="popUpsection = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
    >
      <div
        class="w-full sm:w-[90%] md:w-[70%] lg:w-[40%] bg-white rounded-xl p-6 sm:p-8 md:p-10 overflow-y-auto max-h-[600px]"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-xl font-bold text-blues">Add Slm Module</h3>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt
            @click="popUpsection = false"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col p-4 sm:p-6 relative border border-gray-100 rounded-2xl"
        >
          <div class="w-full">
            <form
              ref="addSection"
              @submit.prevent="createNewsection"
              class="flex flex-col gap-4 text-xs sm:text-sm md:text-base h-full"
            >
              <div class="flex flex-col gap-2 w-full">
                <label for="title" class="text-left flex gap-2 items-center"
                  >Title :<span class="text-red-500">*</span></label
                >
                <input
                  id="title"
                  type="text"
                  class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  required
                />
              </div>

              <!-- <div class="flex flex-col gap-2 w-full">
                  <label for="rbt_levels" class="text-left flex gap-2 items-center">RBT Levels <span class="text-red-500">*</span></label>
                  <input
                    id="rbt_levels"
                    type="text"
                    class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    required
                  />
                </div> -->
              <div class="flex flex-col gap-2 w-full">
                <label for="ordering" class="text-left flex gap-2 items-center"
                  >Order :<span class="text-red-500">*</span></label
                >
                <input
                  id="ordering"
                  type="text"
                  placeholder="e.g. 1"
                  inputmode="numeric"
                  @input="
                    $event.target.value = $event.target.value.replace(/\D/g, '')
                  "
                  class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  required
                />
              </div>

              <div class="flex flex-col gap-2 w-full hidden">
                <label for="duration" class="text-left flex gap-2 items-center"
                  >Duration :<span class="text-red-500">*</span>
                  <div class="relative group">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <div
                      class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                    >
                      provide a Mints
                    </div>
                  </div>
                </label>
                <input
                  id="duration"
                  type="number"
                  min="0"
                  @keypress="
                    !/^[0-9]$/.test($event.key) && $event.preventDefault()
                  "
                  @paste="
                    $event.clipboardData.getData('text').match(/[^0-9]/) &&
                      $event.preventDefault()
                  "
                  class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>

              <div class="flex flex-col gap-3">
                <label for="icon" class="text-sm">Icon :</label>
                <select
                  name="icon"
                  id="icon"
                  class="bg-gray-50 border-gray-300 rounded-md p-3 w-full"
                >
                  <option value="" selected>Select</option>
                  <option value="video">video 🎥</option>
                  <option value="download">download ⬇️</option>
                  <option value="document">document 📄</option>
                  <option value="pdf">pdf 📕</option>
                  <option value="word">word 📘</option>
                  <option value="general">general ⚫</option>
                </select>
              </div>

              <div class="flex flex-row gap-4">
                <input id="feedback" type="checkbox" />
                <label for="feedback" class="text-sm font-medium">
                  Enable Feedback
                </label>
              </div>
              <div class="flex flex-row gap-4 items-center">
                <input id="module_lock" type="checkbox" />
                <label for="module_lock" class="text-sm font-medium">
                  Enable Module Locking System
                </label>
              </div>
              <div class="flex flex-row gap-4">
                <input id="publish" type="checkbox" checked v-model="publish" />
                <label for="publish" class="text-sm font-medium">
                  Publish
                </label>
              </div>
              <div class="flex justify-end items-center gap-3">
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                  "
                  class="rounded-lg text-sm px-6 py-2"
                >
                  Submit
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
              <!-- <div class="flex justify-end pb-4 mt-3">
                <button
                  type="submit"
                  class="text-black border border-black rounded-lg text-sm px-6 sm:px-8 md:px-10 py-2 hover:bg-black hover:text-white transition duration-300"
                >
                  Submit
                </button>
              </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- update lesson  -->
    <div
      v-if="popUp"
      @click.self="popUp = false"
      class="fixed inset-0 z-50 flex items-center justify-center px-3 sm:px-6 bg-black/40"
    >
      <div
        class="relative w-full sm:w-[92%] md:w-[85%] lg:w-[65%] max-w-5xl bg-white rounded-xl sm:rounded-2xl shadow-2xl overflow-y-auto max-h-[95vh] sm:max-h-[92vh]"
      >
        <!-- Header -->
        <div
          class="sticky top-0 z-10 bg-white/95 border-b border-gray-100 px-4 py-3 sm:px-8 sm:py-5 rounded-t-xl sm:rounded-t-2xl"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-base sm:text-xl font-bold text-blues">
              Update SLM Unit
            </h3>
            <button
              @click="popUp = false"
              class="p-1.5 sm:p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 group"
            >
              <svg
                class="w-4 h-4 sm:w-5 sm:h-5 text-gray-500 group-hover:text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Body -->
        <div
          class="px-4 py-4 sm:px-8 sm:py-6"
          v-if="lessonVal.scrom_file == null"
        >
          <form
            ref="lessonaddFn"
            @submit.prevent="updateLesson"
            class="space-y-4 sm:space-y-6"
          >
            <!-- Form Grid -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-5">
              <div class="flex flex-col gap-1">
                <label for="title" class="text-sm font-medium text-gray-700">
                  Title <span class="text-red-500">*</span>
                </label>
                <input
                  id="title"
                  type="text"
                  v-model="lessonVal.title"
                  placeholder="Enter lesson title"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>
              <div class="flex flex-col gap-1">
                <label for="duration" class="text-sm font-medium text-gray-700">
                  Duration <span class="text-red-500">*</span>
                </label>
                <input
                  id="duration"
                  type="number"
                  min="0"
                  @keypress="
                    !/^[0-9]$/.test($event.key) && $event.preventDefault()
                  "
                  @paste="
                    $event.clipboardData.getData('text').match(/[^0-9]/) &&
                      $event.preventDefault()
                  "
                  v-model="lessonVal.duration"
                  placeholder="e.g. 90"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
                <p class="text-xs text-gray-500">
                  Please enter the duration in minutes (e.g., 90).
                </p>
              </div>
            </div>

            <!-- Module Selection -->
            <div class="flex flex-col gap-1">
              <label for="section" class="text-sm font-medium text-gray-700"
                >Module <span class="text-red-500">*</span></label
              >
              <select
                name="section"
                id="section"
                class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                v-model="lessonVal.section_id"
              >
                <option value="" disabled>Select module</option>
                <option
                  v-for="section in sectionInfo.data"
                  :key="section.id"
                  :value="section.id"
                >
                  {{ section.title }}
                </option>
              </select>
            </div>

            <!-- Video Upload Section -->
            <div
              class="bg-gray-50/80 rounded-lg sm:rounded-xl p-3 sm:p-5 border border-gray-200/60"
            >
              <div class="space-y-3">
                <div>
                  <label class="text-sm font-medium text-gray-700 block mb-1.5">
                    Select video file to upload
                  </label>
                  <input
                    type="file"
                    class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                    id="fileuploadUpdate"
                    @change="CheckVideoSizeUpload"
                    accept="video/*,.pdf,.doc,.docx,.xls,.xlsx,"
                  />
                  <p class="mt-2 text-[10px] text-gray-500">
                    Accepted formats: Video, PDF, DOC, DOCX, XLS, XLSX
                  </p>
                  <p
                    v-if="video_error"
                    class="text-red-500 text-xs sm:text-sm mt-1.5"
                  >
                    {{ video_error }}
                  </p>
                </div>
                <div class="flex items-center gap-4 w-full">
                  <!-- Progress -->
                  <div class="flex-1">
                    <div
                      v-if="isUploading"
                      class="w-full h-2 bg-gray-200 rounded-full overflow-hidden"
                    >
                      <div
                        class="h-full bg-blue-600 transition-all duration-300"
                        :style="{ width: uploadProgress + '%' }"
                      ></div>
                    </div>

                    <div
                      class="flex justify-between text-xs text-gray-500 mt-1"
                    >
                      <span
                        v-if="uploadStatusMessage && !video_error"
                        class="upload-status-msg font-medium"
                        >{{ uploadStatusMessage }}</span
                      >
                      <!-- <span id="statusCode"></span> -->
                      <!-- <span v-if="isUploading">{{ uploadProgress }}%</span> -->
                    </div>
                  </div>

                  <!-- Upload Button -->
                  <button
                    type="button"
                    @click.prevent="
                      uploadFilebyChunkNew('fileuploadUpdate', 'getVideoU')
                    "
                    :disabled="disable_update"
                    :class="[
                      disable_update
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700 text-white',
                      'px-4 py-2 rounded-lg text-sm font-medium transition',
                    ]"
                  >
                    {{ disable_update ? "Uploading..." : "Upload" }}
                  </button>
                </div>
              </div>
            </div>

            <div class="flex flex-col gap-1">
              <label for="getVideoU" class="text-sm font-medium text-gray-700"
                >Video URL</label
              >
              <input
                id="getVideoU"
                v-model="lessonVal.video_url"
                type="text"
                placeholder="Paste video URL here"
                class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              />
            </div>

            <!-- Checkboxes Grid -->
            <div class="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  id="show_polls"
                  v-model="lessonVal.show_polls"
                  type="checkbox"
                  class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                />
                <span
                  class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                  >Show Student Polls Count</span
                >
              </label>
              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  id="poll_attempt"
                  v-model="lessonVal.polls"
                  type="checkbox"
                  @change="havePolls('poll_attempt')"
                  class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                />
                <span
                  class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                  >Enable Polls</span
                >
              </label>
              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  id="feedback"
                  v-model="lessonVal.feedback"
                  :checked="lessonVal.feedback"
                  type="checkbox"
                  class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                />
                <span
                  class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                  >Enable Feedback</span
                >
              </label>
              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  id="locking"
                  v-model="lessonVal.locking_status"
                  type="checkbox"
                  class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                />
                <span
                  class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                >
                  Enable Lock Lesson</span
                >
              </label>
            </div>

            <!-- Lock Date -->
            <div
              v-if="lessonVal.locking_status"
              class="bg-gray-50 border border-gray-200 rounded-lg sm:rounded-xl p-3 sm:p-5 animate-fade-in"
            >
              <div class="flex flex-col gap-1">
                <label
                  for="lock_date"
                  class="text-sm font-medium text-gray-700"
                >
                  Select Lock Date<span class="text-red-500">*</span>
                </label>
                <input
                  id="lock_date"
                  type="date"
                  required
                  v-model="lessonVal.locking_date"
                  :min="today"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>
            </div>
            <!-- Polls Section -->
            <div v-if="lessonVal.polls">
              <div
                class="flex flex-col gap-3 w-full"
                v-if="lessonVal.poll_details != null"
              >
                <label for="poll_question" class="text-sm font-medium">
                  Poll Question<span class="text-red-400">*</span>
                </label>
                <input
                  id="poll_question"
                  type="text"
                  placeholder="Enter Question"
                  required
                  v-model="lessonVal.poll_details.question"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
                <div
                  v-for="(poll, index) in lessonVal?.poll_details?.options"
                  :key="index"
                >
                  <div
                    class="w-full flex items-center bg-gray-100 border rounded-lg gap-3"
                  >
                    <input
                      type="text"
                      v-model="poll.text"
                      :placeholder="`Enter Choice  ${index + 1}`"
                      class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                    />
                    <div class="flex items-center gap-3 px-3">
                      <img
                        v-if="index > 0"
                        @click="editAddRow(lessonVal?.poll_details?.options)"
                        src="@/assets/plus.png"
                        alt="add"
                        class="w-6 h-6 object-contain cursor-pointer hidden"
                      />
                      <img
                        v-if="index > 1"
                        @click="
                          editRemoveRow(lessonVal?.poll_details?.options, index)
                        "
                        src="@/assets/remove.png"
                        alt="add"
                        class="w-6 h-6 object-contain cursor-pointer hidden"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="flex flex-col gap-3 w-full"
                v-if="lessonVal.poll_details == null"
              >
                <label for="poll_question" class="text-sm font-medium">
                  Poll Question <span class="text-red-400">*</span>
                </label>
                <input
                  id="poll_question"
                  type="text"
                  placeholder="Enter Question"
                  required
                  v-model="polls_data.question"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
                <div v-for="(poll, index) in polls_data.options" :key="index">
                  <div
                    class="w-full flex items-center bg-gray-100 border rounded-lg gap-3"
                  >
                    <input
                      type="text"
                      v-model="poll.text"
                      :placeholder="`Enter Choice  ${index + 1}`"
                      class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                    />
                    <div class="flex items-center gap-3 px-3">
                      <img
                        v-if="index > 0"
                        @click="addRow"
                        src="@/assets/plus.png"
                        alt="add"
                        class="w-6 h-6 object-contain cursor-pointer"
                      />
                      <img
                        v-if="index > 1"
                        @click="removeRow(index)"
                        src="@/assets/remove.png"
                        alt="add"
                        class="w-6 h-6 object-contain cursor-pointer"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Description -->
            <div class="space-y-1">
              <label class="text-sm font-medium text-gray-700">
                Description <span class="text-red-500">*</span>
              </label>
              <QuillEditor
                class="border border-gray-200 rounded-lg sm:rounded-xl overflow-hidden h-40"
                toolbar="full"
                :content="descriptionUpdate"
                contentType="html"
                theme="snow"
              />
            </div>

            <!-- Additional Fields -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-5">
              <div class="flex flex-col gap-1">
                <label for="keywords" class="text-sm font-medium text-gray-700"
                  >Keywords</label
                >
                <input
                  id="keywords"
                  type="text"
                  v-model="lessonVal.keyworeds"
                  placeholder="Enter keywords"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>
              <div class="flex flex-col gap-1">
                <label for="orderby" class="text-sm font-medium text-gray-700">
                  Order By <span class="text-red-500">*</span>
                </label>
                <input
                  id="orderby"
                  type="text"
                  required
                  v-model="lessonVal.orderby"
                  placeholder="e.g. 1"
                  inputmode="numeric"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  @input="
                    $event.target.value = $event.target.value.replace(/\D/g, '')
                  "
                />
              </div>
              <div class="flex flex-col gap-1">
                <label for="icon" class="text-sm font-medium text-gray-700"
                  >Icon</label
                >
                <select
                  name="icon"
                  id="icon"
                  v-model="lessonVal.file_type"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                >
                  <option value="" selected>Select icon</option>
                  <option value="video">🎥 Video</option>
                  <option value="download">⬇️ Download</option>
                  <option value="document">📄 Document</option>
                  <option value="pdf">📕 PDF</option>
                  <option value="word">📘 Word</option>
                  <option value="general">⚫ General</option>
                </select>
              </div>
            </div>
            <!-- File Uploads -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-5">
              <div class="flex flex-col gap-1">
                <label for="pdffile" class="text-sm font-medium text-gray-700"
                  >PDF File</label
                >
                <input
                  id="pdf_files"
                  type="file"
                  accept=".pdf"
                  @change="CheckPdfSizeUpload"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                />
                <p v-if="pdf_error" class="text-red-500 text-xs sm:text-sm">
                  {{ pdf_error }}
                </p>
                <div
                  v-if="lessonVal.pdf_file"
                  class="flex items-center gap-2 mt-1"
                >
                  <a
                    :href="lessonVal.pdf_file"
                    class="text-blue-600 text-xs font-semibold max-w-[120px] truncate hover:underline"
                    target="_blank"
                  >
                    {{ getShortName(lessonVal.pdf_file) }}
                  </a>
                  <button
                    v-if="lessonVal.pdf_file"
                    @click="removePDF"
                    type="button"
                    class="text-red-500 hover:text-red-700 text-sm font-bold"
                  >
                    ✕
                  </button>
                </div>
              </div>
              <div class="flex flex-col gap-1">
                <label
                  for="audio_file"
                  class="text-sm font-medium text-gray-700"
                  >Audio File</label
                >
                <input
                  id="audiofile"
                  type="file"
                  accept="audio/*"
                  @change="CheckAudioSizeUpload"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                />
                <p v-if="audio_error" class="text-red-500 text-xs sm:text-sm">
                  {{ audio_error }}
                </p>
                <div
                  v-if="lessonVal.audio_file"
                  class="flex items-center gap-2 mt-1"
                >
                  <a
                    :href="lessonVal.audio_file"
                    class="text-blue-600 text-xs font-semibold max-w-[120px] truncate hover:underline"
                    target="_blank"
                  >
                    {{ getShortName(lessonVal.audio_file) }}
                  </a>
                  <button
                    @click="removeAudio"
                    type="button"
                    class="text-red-500 hover:text-red-700 text-sm font-bold"
                  >
                    ✕
                  </button>
                </div>
                <audio
                  controls
                  v-if="lessonVal.audio_file"
                  class="rounded-xl mt-2 w-full max-w-[200px]"
                >
                  <source :src="lessonVal.audio_file" type="audio/ogg" />
                  <source :src="lessonVal.audio_file" type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>
            </div>

            <!-- Submit -->
            <div
              class="flex flex-wrap justify-end items-center gap-2 sm:gap-3 pt-3 sm:pt-4 border-t border-gray-200"
            >
              <button
                type="button"
                @click="popUp = false"
                class="px-4 py-2 sm:px-6 sm:py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg sm:rounded-xl transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                :disabled="disable_submit"
                :class="[
                  disable_submit
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700 text-white shadow-sm hover:shadow',
                  'rounded-lg sm:rounded-xl text-sm px-5 py-2 sm:py-2.5 transition-all duration-200 font-medium',
                ]"
              >
                {{ disable_submit ? "Updating..." : "Update" }}
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-5 h-5 sm:w-6 sm:h-6 object-contain"
              />
            </div>
          </form>
        </div>
        <div class="px-4 py-4 sm:px-8 sm:py-6" v-if="lessonVal.scrom_file">
          <form
            ref="lessonaddFn"
            @submit.prevent="updateLesson"
            class="space-y-4 sm:space-y-6"
          >
            <!-- Form Grid -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-5">
              <div class="flex flex-col gap-1">
                <label for="title" class="text-sm font-medium text-gray-700">
                  Title <span class="text-red-500">*</span>
                </label>
                <input
                  id="title"
                  type="text"
                  v-model="lessonVal.title"
                  placeholder="Enter lesson title"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>
            </div>

            <!-- Video Upload Section -->
            <div
              class="bg-gray-50/80 rounded-lg sm:rounded-xl p-3 sm:p-5 border border-gray-200/60"
            >
              <div class="space-y-3">
                <div>
                  <label class="text-sm font-medium text-gray-700 block mb-1.5">
                    Select Zip file to upload
                    <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="file"
                    class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                    id="fileupload"
                    @change="CheckVideoSizeUpload"
                    accept=".zip,application/zip,application/x-zip-compressed"
                    required
                  />
                  <p
                    v-if="video_error"
                    class="text-red-500 text-xs sm:text-sm mt-1.5"
                  >
                    {{ video_error }}
                  </p>
                </div>
                <div
                  class="flex flex-col md:flex-row items-start md:items-center gap-4 w-full"
                >
                  <div class="flex-1 w-full space-y-2">
                    <div v-if="isUploading" class="w-full">
                      <div
                        class="flex justify-between text-xs text-gray-500 mb-1 tabular-nums"
                      >
                        <span id="statusCode">Uploading file...</span>
                        <span>{{ uploadProgress }}%</span>
                      </div>
                      <div
                        class="w-full h-2 bg-gray-100 rounded-full overflow-hidden shadow-inner"
                      >
                        <div
                          class="h-full bg-blue-600 transition-all duration-300 ease-out"
                          :style="{ width: uploadProgress + '%' }"
                        ></div>
                      </div>
                    </div>

                    <div class="w-full">
                      <div class="text-sm font-medium">
                        <p
                          v-if="processing"
                          class="text-amber-600 flex items-center gap-1.5"
                        >
                          <span class="animate-pulse">⏳</span>
                          {{ processingMessage }}
                        </p>

                        <p
                          v-else-if="
                            packageInfo &&
                            packageInfo.progress_status === 'Completed'
                          "
                          class="text-green-600 flex items-center gap-1.5"
                        >
                          <span>✅</span> SCORM Package Processed Successfully
                        </p>

                        <p
                          v-else-if="
                            packageInfo &&
                            packageInfo.progress_status === 'Failed'
                          "
                          class="text-red-600 flex items-center gap-1.5"
                        >
                          <span>❌</span>
                          {{
                            packageInfo.description ||
                            "SCORM Package Processing Failed"
                          }}
                        </p>
                      </div>

                      <div v-if="processing" class="mt-2 w-full">
                        <div
                          class="w-full h-2 bg-gray-100 rounded-full overflow-hidden shadow-inner"
                        >
                          <div
                            class="h-full bg-amber-500 transition-all duration-300 ease-out"
                            :style="{
                              width: packageInfo
                                ? packageInfo.progress + '%'
                                : '0%',
                            }"
                          ></div>
                        </div>
                        <div
                          class="text-xs text-gray-500 mt-1 text-right tabular-nums"
                        >
                          Processing:
                          {{ packageInfo ? packageInfo.progress : 0 }}%
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    @click.prevent="
                      uploadScormChunkNew('fileupload', 'zipUrlNew')
                    "
                    :disabled="disable_update || processing"
                    :class="[
                      disable_update || processing
                        ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700 text-white active:scale-[0.98]',
                      'px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 shrink-0 w-full md:w-auto self-end md:self-auto',
                    ]"
                  >
                    {{
                      disable_update
                        ? "Uploading..."
                        : processing
                        ? "Processing..."
                        : "Upload"
                    }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Video URL -->
            <div class="flex flex-col gap-1">
              <label for="Zip URL" class="text-sm font-medium text-gray-700"
                >Zip URL</label
              >
              <input
                type="text"
                v-model="lessonVal.scrom_url"
                placeholder="Zip URL"
                class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              />
            </div>

            <!-- Checkboxes Grid -->
            <div class="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  id="feedback"
                  v-model="lessonVal.feedback"
                  :checked="lessonVal.feedback"
                  type="checkbox"
                  class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                />
                <span
                  class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                  >Enable Feedback</span
                >
              </label>
              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  id="locking"
                  v-model="lessonVal.locking_status"
                  type="checkbox"
                  class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                />
                <span
                  class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                >
                  Enable Lock Lesson</span
                >
              </label>
            </div>

            <!-- Lock Date -->
            <div
              v-if="lessonVal.locking_status"
              class="bg-gray-50 border border-gray-200 rounded-lg sm:rounded-xl p-3 sm:p-5 animate-fade-in"
            >
              <div class="flex flex-col gap-1">
                <label
                  for="lock_date"
                  class="text-sm font-medium text-gray-700"
                >
                  Select Lock Date<span class="text-red-500">*</span>
                </label>
                <input
                  id="lock_date"
                  type="date"
                  required
                  v-model="lessonVal.locking_date"
                  :min="today"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>
            </div>

            <!-- Additional Fields -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-5">
              <div class="flex flex-col gap-1">
                <label for="orderby" class="text-sm font-medium text-gray-700">
                  Order By <span class="text-red-500">*</span>
                </label>
                <input
                  id="orderby"
                  type="text"
                  required
                  v-model="lessonVal.orderby"
                  placeholder="e.g. 1"
                  inputmode="numeric"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  @input="
                    $event.target.value = $event.target.value.replace(/\D/g, '')
                  "
                />
              </div>
              <div class="flex flex-col gap-1">
                <label for="icon" class="text-sm font-medium text-gray-700"
                  >Icon</label
                >
                <select
                  name="icon"
                  id="icon"
                  v-model="lessonVal.file_type"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                >
                  <option value="" selected>Select icon</option>
                  <option value="video">🎥 Video</option>
                  <option value="download">⬇️ Download</option>
                  <option value="document">📄 Document</option>
                  <option value="pdf">📕 PDF</option>
                  <option value="word">📘 Word</option>
                  <option value="general">⚫ General</option>
                </select>
              </div>
            </div>

            <!-- Submit -->
            <div
              class="flex flex-wrap justify-end items-center gap-2 sm:gap-3 pt-3 sm:pt-4 border-t border-gray-200"
            >
              <button
                type="button"
                @click="popUp = false"
                class="px-4 py-2 sm:px-6 sm:py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg sm:rounded-xl transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                :disabled="disable_submit"
                :class="[
                  disable_submit
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700 text-white shadow-sm hover:shadow',
                  'rounded-lg sm:rounded-xl text-sm px-5 py-2 sm:py-2.5 transition-all duration-200 font-medium',
                ]"
              >
                {{ disable_submit ? "Updating..." : "Update" }}
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-5 h-5 sm:w-6 sm:h-6 object-contain"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Add Lesson  -->
    <div
      v-if="popUpLesson"
      @click.self="popUpLesson = false"
      class="fixed inset-0 z-50 flex items-center justify-center px-3 sm:px-6 bg-black/40"
    >
      <div
        class="relative w-full sm:w-[92%] md:w-[85%] lg:w-[65%] max-w-5xl bg-white rounded-xl sm:rounded-2xl shadow-2xl overflow-y-auto max-h-[95vh] sm:max-h-[92vh]"
      >
        <!-- Header -->
        <div
          class="sticky top-0 z-10 bg-white/95 border-b border-gray-100 px-4 py-3 sm:px-8 sm:py-5 rounded-t-xl sm:rounded-t-2xl"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-base sm:text-xl font-bold text-blues">
              Add SLM Unit
            </h3>
            <button
              @click="
                lessonType === 'scorm'
                  ? closeScormResetModal()
                  : closeLessonResetModal()
              "
              class="p-1.5 sm:p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 group"
            >
              <svg
                class="w-4 h-4 sm:w-5 sm:h-5 text-gray-500 group-hover:text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Body -->
        <div class="px-4 py-4 sm:px-8 sm:py-6">
          <!-- Lesson Type Selection -->
          <div class="flex flex-wrap items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="radio"
                value="standard"
                v-model="lessonType"
                class="w-4 h-4 text-blue-600 focus:ring-blue-500 focus:ring-2 transition-all"
              />
              <span
                class="text-sm font-medium text-gray-700 group-hover:text-gray-900"
                >Standard</span
              >
            </label>
            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="radio"
                value="scorm"
                v-model="lessonType"
                class="w-4 h-4 text-blue-600 focus:ring-blue-500 focus:ring-2 transition-all"
              />
              <span
                class="text-sm font-medium text-gray-700 group-hover:text-gray-900"
                >SCORM</span
              >
            </label>
          </div>

          <!-- Standard Lesson Form -->
          <div v-if="lessonType === 'standard'" class="space-y-4 sm:space-y-6">
            <form
              ref="lessonaddFnadd"
              @submit.prevent="createNewLesson"
              class="space-y-4 sm:space-y-6"
            >
              <!-- Form Grid -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-5">
                <div class="flex flex-col gap-1">
                  <label for="title" class="text-sm font-medium text-gray-700">
                    Title <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="title"
                    type="text"
                    required
                    placeholder="Enter lesson title"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div class="flex flex-col gap-1">
                  <label
                    for="duration"
                    class="text-sm font-medium text-gray-700"
                  >
                    Duration <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="duration"
                    type="number"
                    min="0"
                    @keypress="
                      !/^[0-9]$/.test($event.key) && $event.preventDefault()
                    "
                    @paste="
                      $event.clipboardData.getData('text').match(/[^0-9]/) &&
                        $event.preventDefault()
                    "
                    required
                    placeholder="e.g. 90"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <p class="text-xs text-gray-500">
                    Please enter the duration in minutes (e.g., 90).
                  </p>
                </div>
              </div>

              <!-- Video Upload Section -->
              <div
                class="bg-gray-50/80 rounded-lg sm:rounded-xl p-3 sm:p-5 border border-gray-200/60"
              >
                <div class="space-y-3">
                  <div>
                    <label
                      class="text-sm font-medium text-gray-700 block mb-1.5"
                    >
                      Select video file to upload
                    </label>
                    <input
                      type="file"
                      class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                      id="fileupload"
                      @change="CheckVideoSizeUpload"
                      accept="video/*,.pdf,.doc,.docx,.xls,.xlsx,"
                    />
                    <p class="mt-2 text-[10px] text-gray-500">
                      Accepted formats: Video, PDF, DOC, DOCX, XLS, XLSX
                    </p>
                    <p
                      v-if="video_error"
                      class="text-red-500 text-xs sm:text-sm mt-1.5"
                    >
                      {{ video_error }}
                    </p>
                  </div>
                  <div class="flex items-center gap-4 w-full">
                    <!-- Progress -->
                    <div class="flex-1">
                      <div
                        v-if="isUploading"
                        class="w-full h-2 bg-gray-200 rounded-full overflow-hidden"
                      >
                        <div
                          class="h-full bg-blue-600 transition-all duration-300"
                          :style="{ width: uploadProgress + '%' }"
                        ></div>
                      </div>

                      <div
                        class="flex justify-between text-xs text-gray-500 mt-1"
                      >
                        <span
                          v-if="uploadStatusMessage && !video_error"
                          class="upload-status-msg font-medium"
                          >{{ uploadStatusMessage }}</span
                        >
                        <!-- <span v-if="isUploading">{{ uploadProgress }}%</span> -->
                      </div>
                    </div>

                    <!-- Upload Button -->
                    <button
                      type="button"
                      @click.prevent="
                        uploadFilebyChunkNew('fileupload', 'videoUrlNew')
                      "
                      :disabled="disable_update"
                      :class="[
                        disable_update
                          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          : 'bg-blue-600 hover:bg-blue-700 text-white',
                        'px-4 py-2 rounded-lg text-sm font-medium transition',
                      ]"
                    >
                      {{ disable_update ? "Uploading..." : "Upload" }}
                    </button>
                  </div>
                </div>
                <!-- <div id="uploaded_files" class="mt-2"></div> -->
              </div>

              <!-- Video URL -->
              <div class="flex flex-col gap-1">
                <label
                  for="videoUrlNew"
                  class="text-sm font-medium text-gray-700"
                  >Video URL</label
                >
                <input
                  id="videoUrlNew"
                  type="text"
                  @mouseleave="convertToEmbed('videoUrlNew')"
                  placeholder="Paste video URL here"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>

              <!-- Checkboxes Grid -->
              <div class="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                <label class="flex items-center gap-2 cursor-pointer group">
                  <input
                    id="show_polls"
                    type="checkbox"
                    class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                  />
                  <span
                    class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                    >Show Student Polls Count</span
                  >
                </label>
                <label class="flex items-center gap-2 cursor-pointer group">
                  <input
                    id="poll_attempt"
                    type="checkbox"
                    @change="havePolls('poll_attempt')"
                    class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                  />
                  <span
                    class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                    >Enable Polls</span
                  >
                </label>
                <label class="flex items-center gap-2 cursor-pointer group">
                  <input
                    id="feedback"
                    type="checkbox"
                    class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                  />
                  <span
                    class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                    >Enable Feedback</span
                  >
                </label>
                <label class="flex items-center gap-2 cursor-pointer group">
                  <input
                    id="lock_attempt"
                    type="checkbox"
                    @change="haveLocks('lock_attempt')"
                    class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                  />
                  <span
                    class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                    >Lesson Lock</span
                  >
                </label>
              </div>

              <!-- Lock Date -->
              <div
                v-if="check_locks"
                class="bg-gray-50 border border-gray-200 rounded-lg sm:rounded-xl p-3 sm:p-5 animate-fade-in"
              >
                <div class="flex flex-col gap-1">
                  <label
                    for="lock_date"
                    class="text-sm font-medium text-gray-700"
                  >
                    Select Lock Date <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="lock_date"
                    type="date"
                    required
                    v-model="lock_data"
                    :min="today"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                </div>
              </div>

              <!-- Polls Section -->
              <div
                v-if="check_polls"
                class="bg-blue-50/60 border border-blue-200 rounded-lg sm:rounded-xl p-3 sm:p-5 animate-fade-in"
              >
                <div class="flex flex-col gap-2">
                  <label
                    for="poll_question"
                    class="text-sm font-medium text-gray-700 block"
                  >
                    Poll Question <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="poll_question"
                    type="text"
                    placeholder="Enter your poll question"
                    required
                    v-model="polls_data.question"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <div
                    v-for="(poll, index) in polls_data.options"
                    :key="index"
                    class="flex items-center gap-2"
                  >
                    <div class="flex-1">
                      <input
                        type="text"
                        v-model="poll.text"
                        :placeholder="`Enter Choice ${index + 1}`"
                        class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                      />
                    </div>
                    <div class="flex items-center gap-1 shrink-0">
                      <button
                        v-if="index > 0"
                        @click="addRow"
                        type="button"
                        class="p-1.5 sm:p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                      >
                        <svg
                          class="w-4 h-4 sm:w-5 sm:h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 4v16m8-8H4"
                          />
                        </svg>
                      </button>
                      <button
                        v-if="index > 1"
                        @click="removeRow(index)"
                        type="button"
                        class="p-1.5 sm:p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                      >
                        <svg
                          class="w-4 h-4 sm:w-5 sm:h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Description -->
              <div class="space-y-1">
                <label class="text-sm font-medium text-gray-700">
                  Description <span class="text-red-500">*</span>
                </label>
                <QuillEditor
                  class="border border-gray-200 rounded-lg sm:rounded-xl overflow-hidden h-40"
                  toolbar="full"
                  :content="description"
                  contentType="html"
                  theme="snow"
                />
              </div>

              <!-- Additional Fields -->
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-5">
                <div class="flex flex-col gap-1">
                  <label
                    for="keywords"
                    class="text-sm font-medium text-gray-700"
                    >Keywords</label
                  >
                  <input
                    id="keywords"
                    type="text"
                    placeholder="Enter keywords"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div class="flex flex-col gap-1">
                  <label
                    for="orderby"
                    class="text-sm font-medium text-gray-700"
                  >
                    Order By <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="orderby"
                    type="text"
                    required
                    placeholder="e.g. 1"
                    inputmode="numeric"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                    @input="
                      $event.target.value = $event.target.value.replace(
                        /\D/g,
                        '',
                      )
                    "
                  />
                </div>
                <div class="flex flex-col gap-1">
                  <label for="icon" class="text-sm font-medium text-gray-700"
                    >Icon</label
                  >
                  <select
                    name="icon"
                    id="icon"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  >
                    <option value="" selected>Select icon</option>
                    <option value="video">🎥 Video</option>
                    <option value="download">⬇️ Download</option>
                    <option value="document">📄 Document</option>
                    <option value="pdf">📕 PDF</option>
                    <option value="word">📘 Word</option>
                  </select>
                </div>
              </div>

              <!-- File Uploads -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-5">
                <div class="flex flex-col gap-1">
                  <label for="pdffile" class="text-sm font-medium text-gray-700"
                    >PDF File</label
                  >
                  <input
                    id="pdffile"
                    type="file"
                    accept=".pdf"
                    @change="CheckPdfSizeUpload"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                  />
                  <p v-if="pdf_error" class="text-red-500 text-xs sm:text-sm">
                    {{ pdf_error }}
                  </p>
                </div>
                <div class="flex flex-col gap-1">
                  <label
                    for="audio_file"
                    class="text-sm font-medium text-gray-700"
                    >Audio File</label
                  >
                  <input
                    id="audio_file"
                    type="file"
                    accept="audio/*"
                    @change="CheckAudioSizeUpload"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                  />
                  <p v-if="audio_error" class="text-red-500 text-xs sm:text-sm">
                    {{ audio_error }}
                  </p>
                </div>
              </div>

              <!-- Submit -->
              <div
                class="flex flex-wrap justify-end items-center gap-2 sm:gap-3 pt-3 sm:pt-4 border-t border-gray-200"
              >
                <button
                  type="button"
                  @click="closeLessonResetModal"
                  class="px-4 py-2 sm:px-6 sm:py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg sm:rounded-xl transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  :disabled="disable_submit"
                  :class="[
                    disable_submit
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : 'bg-blue-600 hover:bg-blue-700 text-white shadow-sm hover:shadow',
                    'rounded-lg sm:rounded-xl text-sm px-5 py-2  sm:py-2.5 transition-all duration-200 font-medium',
                  ]"
                >
                  {{ disable_submit ? "Saving..." : "Save" }}
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-5 h-5 sm:w-6 sm:h-6 object-contain"
                />
              </div>
            </form>
          </div>

          <!-- SCORM Lesson Form -->
          <div v-if="lessonType === 'scorm'" class="space-y-4 sm:space-y-6">
            <form
              ref="lessonaddFnadd"
              @submit.prevent="createNewLesson"
              class="space-y-4 sm:space-y-6"
            >
              <div class="flex flex-col gap-1">
                <label for="title" class="text-sm font-medium text-gray-700">
                  Title <span class="text-red-500">*</span>
                </label>
                <input
                  id="title"
                  type="text"
                  required
                  placeholder="Enter SCORM lesson title"
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>

              <!-- Video Upload Section (same as standard) -->
              <div
                class="bg-gray-50/80 rounded-lg sm:rounded-xl p-3 sm:p-5 border border-gray-200/60"
              >
                <div class="space-y-3">
                  <div>
                    <label
                      class="text-sm font-medium text-gray-700 block mb-1.5"
                    >
                      Select Zip file to upload
                      <span class="text-red-500">*</span>
                    </label>
                    <input
                      type="file"
                      class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                      id="fileupload"
                      @change="CheckVideoSizeUpload"
                      accept=".zip,application/zip,application/x-zip-compressed"
                      required
                    />
                    <p
                      v-if="video_error"
                      class="text-red-500 text-xs sm:text-sm mt-1.5"
                    >
                      {{ video_error }}
                    </p>
                  </div>
                  <div
                    class="flex flex-col md:flex-row items-start md:items-center gap-4 w-full"
                  >
                    <div class="flex-1 w-full space-y-2">
                      <div v-if="isUploading" class="w-full">
                        <div
                          class="flex justify-between text-xs text-gray-500 mb-1 tabular-nums"
                        >
                          <span id="statusCode">Uploading file...</span>
                          <span>{{ uploadProgress }}%</span>
                        </div>
                        <div
                          class="w-full h-2 bg-gray-100 rounded-full overflow-hidden shadow-inner"
                        >
                          <div
                            class="h-full bg-blue-600 transition-all duration-300 ease-out"
                            :style="{ width: uploadProgress + '%' }"
                          ></div>
                        </div>
                      </div>

                      <div class="w-full">
                        <div class="text-sm font-medium">
                          <p
                            v-if="processing"
                            class="text-amber-600 flex items-center gap-1.5"
                          >
                            <span class="animate-pulse">⏳</span>
                            {{ processingMessage }}
                          </p>

                          <p
                            v-else-if="packageInfo && packageInfo.status"
                            class="text-green-600 flex items-center gap-1.5"
                          >
                            <span>✅</span> SCORM Package Processed Successfully
                          </p>

                          <p
                            v-else-if="packageInfo && !packageInfo.status"
                            class="text-red-600 flex items-center gap-1.5"
                          >
                            <span>❌</span>
                            {{
                              packageInfo.description ||
                              "SCORM Package Processing Failed"
                            }}
                          </p>
                        </div>

                        <div v-if="processing" class="mt-2 w-full">
                          <div
                            class="w-full h-2 bg-gray-100 rounded-full overflow-hidden shadow-inner"
                          >
                            <div
                              class="h-full bg-amber-500 transition-all duration-300 ease-out"
                              :style="{
                                width: packageInfo
                                  ? packageInfo.progress + '%'
                                  : '0%',
                              }"
                            ></div>
                          </div>
                          <div
                            class="text-xs text-gray-500 mt-1 text-right tabular-nums"
                          >
                            Processing:
                            {{ packageInfo ? packageInfo.progress : 0 }}%
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      type="button"
                      @click.prevent="
                        uploadScormChunkNew('fileupload', 'zipUrlNew')
                      "
                      :disabled="disable_update || processing"
                      :class="[
                        disable_update || processing
                          ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                          : 'bg-blue-600 hover:bg-blue-700 text-white active:scale-[0.98]',
                        'px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 shrink-0 w-full md:w-auto self-end md:self-auto',
                      ]"
                    >
                      {{
                        disable_update
                          ? "Uploading..."
                          : processing
                          ? "Processing..."
                          : "Upload"
                      }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- SCORM Checkboxes -->
              <div class="grid grid-cols-2 gap-3 sm:gap-4">
                <label class="flex items-center gap-2 cursor-pointer group">
                  <input
                    id="feedback"
                    type="checkbox"
                    class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                  />
                  <span
                    class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                    >Enable Feedback</span
                  >
                </label>
                <label class="flex items-center gap-2 cursor-pointer group">
                  <input
                    id="lock_attempt"
                    type="checkbox"
                    @change="haveLocks('lock_attempt')"
                    class="w-4 h-4 text-blue-600 focus:ring-blue-500 rounded shrink-0"
                  />
                  <span
                    class="text-xs sm:text-sm text-gray-700 group-hover:text-gray-900"
                    >Lesson Lock</span
                  >
                </label>
              </div>

              <!-- Lock Date -->
              <div
                v-if="check_locks"
                class="bg-gray-50 border border-gray-200 rounded-lg sm:rounded-xl p-3 sm:p-5 animate-fade-in"
              >
                <div class="flex flex-col gap-1">
                  <label
                    for="lock_date"
                    class="text-sm font-medium text-gray-700"
                  >
                    Select Lock Date <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="lock_date"
                    type="date"
                    required
                    v-model="lock_data"
                    :min="today"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                </div>
              </div>

              <!-- SCORM Additional Fields -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-5">
                <div class="flex flex-col gap-1">
                  <label
                    for="orderby"
                    class="text-sm font-medium text-gray-700"
                  >
                    Order By <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="orderby"
                    type="text"
                    required
                    placeholder="e.g. 1"
                    inputmode="numeric"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                    @input="
                      $event.target.value = $event.target.value.replace(
                        /\D/g,
                        '',
                      )
                    "
                  />
                </div>
                <div class="flex flex-col gap-1">
                  <label for="icon" class="text-sm font-medium text-gray-700"
                    >Icon</label
                  >
                  <select
                    name="icon"
                    id="icon"
                    class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  >
                    <option value="" selected>Select icon</option>
                    <option value="video">🎥 Video</option>
                    <option value="download">⬇️ Download</option>
                    <option value="document">📄 Document</option>
                    <option value="pdf">📕 PDF</option>
                    <option value="word">📘 Word</option>
                  </select>
                </div>
              </div>

              <!-- Submit -->
              <div
                class="flex flex-wrap justify-end items-center gap-2 sm:gap-3 pt-3 sm:pt-4 border-t border-gray-200"
              >
                <button
                  type="button"
                  @click="closeScormResetModal"
                  class="px-4 py-2 sm:px-6 sm:py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg sm:rounded-xl transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  :disabled="disable_submit"
                  :class="[
                    disable_submit
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : 'bg-blue-600 hover:bg-blue-700 text-white shadow-sm hover:shadow',
                    'rounded-lg sm:rounded-xl text-sm px-5 py-2 sm:px-8 sm:py-2.5 transition-all duration-200 font-medium',
                  ]"
                >
                  {{ disable_submit ? "Saving..." : "Save" }}
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-5 h-5 sm:w-6 sm:h-6 object-contain"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Quiz -->
    <div
      v-if="popUpQuiz"
      @click.self="popUpQuiz = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
    >
      <div
        class="w-full md:w-[80%] lg:w-[60%] bg-white rounded-xl p-3 md:p-10 overflow-y-auto h-[90%]"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <h3
              class="text-base font-bold px-4 py-1 rounded-xl cursor-pointer text-blues"
            >
              Add Quiz
            </h3>
          </div>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt="Close"
            @click="closepoup()"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col md:p-6 relative border border-gray-100 rounded-2xl"
        >
          <form
            ref="addQuizRefs"
            @submit.prevent="createQuizOfSection"
            class="w-full flex flex-col gap-3"
          >
            <div class="flex flex-col gap-3 w-full">
              <label for="title" class="text-sm font-medium">
                Title <span class="text-red-400">*</span>
              </label>
              <input
                id="title"
                type="text"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
              />
            </div>

            <div class="flex flex-col gap-3 w-full">
              <label for="content" class="text-sm font-medium">
                Content <span class="text-red-400">*</span>
              </label>
              <input
                id="content"
                type="text"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
              />
            </div>
            <!-- lesson_or_quiz -->
            <div class="flex flex-row gap-4" v-if="!hidePercentage">
              <input
                id="Percentage"
                type="checkbox"
                @change="havePercentage('Percentage')"
              />
              <label for="Percentage" class="text-sm font-medium">
                Quizs Percentage
              </label>
            </div>

            <div class="flex flex-col gap-3 w-full" v-if="checkedPercentage">
              <label for="question_attempt_count" class="text-sm font-medium">
                Percentage Count<span class="text-red-400">*</span>
              </label>
              <input
                id="Percentage_count"
                type="number"
                required
                placeholder="Please enter the integer "
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                max="100"
              />
            </div>
            <div class="flex flex-row gap-4" v-if="!hideattempt">
              <input
                id="question_attempt"
                type="checkbox"
                @change="haveAttempt('question_attempt')"
              />
              <label for="question_attempt" class="text-sm font-medium">
                Mutiple Attempt
              </label>
            </div>
            <div class="flex flex-col gap-3 w-full" v-if="checkedAttempt">
              <label for="question_attempt_count" class="text-sm font-medium">
                Attempt Count <span class="text-red-400">*</span>
              </label>
              <input
                id="question_attempt_count"
                type="number"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                max="100"
              />
            </div>

            <div class="flex flex-row gap-4">
              <input id="feedback" type="checkbox" />
              <label for="feedback" class="text-sm font-medium">
                Enable Feedback
              </label>
            </div>

            <div class="flex flex-col gap-3 w-full">
              <label for="order" class="text-sm font-medium">
                Order By <span class="text-red-400">*</span>
              </label>
              <input
                id="order"
                type="text"
                required
                placeholder="e.g. 1"
                inputmode="numeric"
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                @input="
                  $event.target.value = $event.target.value.replace(/\D/g, '')
                "
              />
            </div>
            <div class="flex flex-col gap-1 w-full">
              <label for="duration" class="text-sm font-medium">
                Test Duration <span class="text-red-400">*</span>
              </label>
              <input
                id="duration"
                type="number"
                min="0"
                @keypress="
                  !/^[0-9]$/.test($event.key) && $event.preventDefault()
                "
                @paste="
                  $event.clipboardData.getData('text').match(/[^0-9]/) &&
                    $event.preventDefault()
                "
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
              />
              <p class="text-xs text-gray-500">
                Please enter the duration in minutes (e.g., 90).
              </p>
            </div>

            <!-- <div class="flex items-center gap-2">
                  <input type="radio" name="selectOption" id="" value="choice" v-model="choiceType"> Choice Type
                  <input type="radio" name="selectOption" id="" value="short" v-model="choiceType"> Short Answer
                  <input type="radio" name="selectOption" id="" value="long" v-model="choiceType"> Long Answer
                </div> -->

            <div class="flex flex-col gap-5">
              <div
                v-for="(form, index) in forms"
                :key="index"
                class="w-full mt-3 bg-gray-200 rounded-lg lg:p-4"
              >
                <div class="flex flex-col gap-5">
                  <div
                    class="flex items-center justify-between bg-primary px-4 py-2 md:px-6 md:py-3 rounded-t-lg w-full"
                  >
                    <label class="text-lg text-white"
                      >Question {{ index + 1 }}:</label
                    >
                    <button
                      v-if="index != 0"
                      type="button"
                      class="bg-red-700 text-xs text-white rounded-md px-3 py-1"
                      @click="removeForm(index)"
                    >
                      Remove Question
                    </button>
                  </div>

                  <div class="px-4 sm:px-6 py-2">
                    <textarea
                      v-model="form.question_text"
                      rows="2"
                      required
                      class="p-2 sm:p-4 md:p-4 rounded-md w-full text-sm sm:text-base"
                      placeholder="Enter your question"
                    >
                    </textarea>
                  </div>
                </div>

                <div
                  class="flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4 px-4 sm:px-6 py-2"
                >
                  <div>
                    <input
                      type="radio"
                      value="choice"
                      v-model="form.choice_type"
                    />
                    Choice Type
                  </div>
                  <!-- <div>
                    <input
                      type="radio"
                      value="coding"
                      v-model="form.choice_type"
                    />
                    Coding
                  </div> -->
                  <!-- <div>
                    <input
                      type="radio"
                      value="truefalse"
                      v-model="form.choice_type"
                    />
                    True or False
                  </div> -->
                  <!-- <div>
                    <input
                      type="radio"
                      value="matchthefollowing"
                      v-model="form.choice_type"
                    />
                    Match the following
                  </div> -->
                  <!-- <div>
                    <input
                      type="radio"
                      value="shortdescription"
                      v-model="form.choice_type"
                    />
                    Short Answer
                  </div> -->
                  <!-- <div>
                    <input
                      type="radio"
                      value="description"
                      v-model="form.choice_type"
                    />
                    Long Answer
                  </div> -->
                </div>

                <!-- {{ form.choiceType }} -->
                <div
                  v-if="form.choice_type == 'matchthefollowing'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <div
                    v-for="(address, addrIndex) in form.matchthefollowing"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <!-- <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    > -->
                    <input
                      type="text"
                      v-model="address['left_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter Left Option"
                      required
                    />
                    <input
                      type="text"
                      v-model="address['right_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter Right Option"
                      required
                    />
                    <button
                      type="button"
                      class="bg-red-500 rounded-lg text-white text-xs px-2 py-1"
                      @click="removeMatchtheFollowing(index)"
                    >
                      remove
                    </button>
                    <!-- right_text -->
                    <!-- <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    /> -->
                    <!-- <label class="text-sm">Is Answer</label> -->
                  </div>

                  <button
                    type="button"
                    @click="addMoreMatchtheFollowing(index)"
                    class="bg-blues text-sm text-white rounded-md px-4 py-2"
                  >
                    Add More
                  </button>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>
                <div
                  v-if="form.choice_type == 'coding'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <label
                    for="language"
                    class="text-sm font-semibold text-gray-700"
                  >
                    Select Programming Language:
                  </label>
                  <select
                    id="programming_language"
                    v-model="form.programming_language"
                    class="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option disabled value="">Select Language</option>
                    <option value="python">Python</option>
                    <!-- <option value="java">Java</option> -->
                    <option value="cpp">C++</option>
                    <option value="c">C</option>
                    <!-- <option value="javascript">JavaScript</option> -->
                  </select>
                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'truefalse'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <div
                    v-for="(address, addrIndex) in form.truefalse"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <!-- <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    > -->
                    <label class="text-sm text-gray-700"> </label>
                    <!-- <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    /> -->
                    <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    />
                    <!-- right_text -->
                    <!-- <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    /> -->
                    <label class="text-sm"
                      ><span v-if="addrIndex == 0">True</span>
                      <span v-else>False</span></label
                    >
                  </div>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'choice'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <div
                    v-for="(address, addrIndex) in form.answers"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    >
                    <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    />
                    <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    />
                    <label class="text-sm">Is Answer</label>

                    <button
                      type="button"
                      class="bg-red-500 rounded-lg text-white text-xs px-2 py-1"
                      @click="removeChoiceType(index, addrIndex)"
                    >
                      remove
                    </button>
                  </div>

                  <button
                    type="button"
                    @click="addMoreChoiceType(index)"
                    class="bg-blues text-sm text-white rounded-md px-4 py-2"
                  >
                    Add More
                  </button>

                  <input
                    type="text"
                    v-model.number="form.max_mark"
                    required
                    maxlength="1"
                    @input="
                      form.max_mark = $event.target.value.replace(/[^1-9]/g, '')
                        ? Number($event.target.value.replace(/[^1-9]/g, ''))
                        : null
                    "
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter mark (1-9)"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'shortdescription'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <textarea
                    rows="3"
                    v-model="form.shortAnswerMark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter your answer"
                    required
                  >
                  </textarea>
                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'description'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <textarea
                    rows="10"
                    v-model="form.longAnswerMark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter your answer"
                    required
                  >
                  </textarea>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    placeholder="Add Mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                  />
                </div>
              </div>
            </div>

            <div class="flex justify-end gap-4 mt-4">
              <button
                type="button"
                @click="addForm"
                class="bg-blues text-sm text-white rounded-md px-4 py-2"
              >
                Add Question
              </button>
              <div class="flex items-center gap-3">
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                  "
                  class="rounded-lg text-sm px-4 py-2"
                >
                  Save
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Update Quiz -->
    <div
      v-if="popUpupdateQuiz"
      @click.self="popUpupdateQuiz = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
    >
      <div
        class="w-full max-w-4xl bg-white rounded-xl p-6 md:p-10 overflow-y-auto h-[95%]"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-bold text-blues">Update Quiz</h3>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt
            @click="popUpupdateQuiz = false"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col p-4 md:p-6 border border-gray-100 rounded-2xl"
        >
          <!-- <pre>{{ currentQuizData }}</pre> -->
          <form
            ref="addQuizRefs"
            @submit.prevent="updateQuizOfSection(currentQuizData.id)"
            class="w-full flex flex-col gap-3"
          >
            <div class="flex flex-col gap-5">
              <!-- <div class="flex items-center justify-end mt-3">
                <button
                  @click="addForm"
                  class="bg-blues text-sm text-white rounded-md px-4 py-2"
                >
                  Add Question
                </button>
              </div> -->
              <div class="flex flex-col gap-3 w-full">
                <label for="title" class="text-sm font-medium">
                  Title<span class="text-red-400">*</span>
                </label>
                <input
                  id="title"
                  type="text"
                  v-model="currentQuizData.lesson_title"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
              </div>

              <div class="flex flex-col gap-3 w-full">
                <label for="content" class="text-sm font-medium">
                  Content <span class="text-red-400">*</span>
                </label>
                <input
                  id="content"
                  type="text"
                  v-model="currentQuizData.lesson_content"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
              </div>
              <div class="flex flex-row gap-3" v-if="!hidePercentage">
                <input
                  id="Percentage"
                  v-model="currentQuizData.persentage"
                  type="checkbox"
                />
                <label for="Percentage" class="text-sm font-medium">
                  Quizs Percentage
                </label>
              </div>
              <div
                class="flex flex-col gap-3 w-full"
                v-if="currentQuizData.persentage"
              >
                <label for="Percentage_count" class="text-sm font-medium">
                  Percentage Count <span class="text-red-400">*</span>
                </label>
                <input
                  id="Percentage_count"
                  v-model="currentQuizData.persentage_score"
                  type="number"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                  max="100"
                />
              </div>
              <div class="flex flex-row gap-3" v-if="!hideattempt">
                <input
                  id="question_attempt"
                  v-model="currentQuizData.question_attempt"
                  type="checkbox"
                />
                <label for="question_attempt" class="text-sm font-medium">
                  Mutiple Attempt
                </label>
              </div>
              <div
                class="flex flex-col gap-3 w-full"
                v-if="currentQuizData.question_attempt"
              >
                <label for="question_attempt_count" class="text-sm font-medium">
                  Attempt Count <span class="text-red-400">*</span>
                </label>
                <input
                  id="question_attempt_count"
                  v-model="currentQuizData.question_attempt_count"
                  type="number"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                  max="100"
                />
              </div>

              <div class="flex flex-row gap-3">
                <input
                  id="feedback"
                  v-model="currentQuizData.quizsfeedback"
                  :checked="currentQuizData.quizsfeedback"
                  type="checkbox"
                />
                <label for="feedback" class="text-sm font-medium">
                  Enable Feedback
                </label>
              </div>

              <div class="flex flex-col gap-3 w-full">
                <label for="order" class="text-sm font-medium">
                  Order By <span class="text-red-400">*</span>
                </label>
                <input
                  id="order"
                  type="number"
                  v-model="currentQuizData.lesson_order"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
              </div>
              <div class="flex flex-col gap-3 w-full">
                <label for="order" class="text-sm font-medium">
                  Test Duration <span class="text-red-400">*</span>
                </label>
                <input
                  id="duration"
                  type="number"
                  min="0"
                  @keypress="
                    !/^[0-9]$/.test($event.key) && $event.preventDefault()
                  "
                  @paste="
                    $event.clipboardData.getData('text').match(/[^0-9]/) &&
                      $event.preventDefault()
                  "
                  v-model="currentQuizData.timer"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
                <p class="text-xs text-gray-500">
                  Please enter the duration in minutes (e.g., 90).
                </p>
              </div>

              <div
                v-for="(form, index) in currentQuizData.questions"
                :key="index"
                class="w-full mt-3 bg-gray-200 rounded-lg p-4"
              >
                <div class="flex flex-col gap-5">
                  <div
                    class="flex items-center justify-between bg-primary px-6 py-3 rounded-t-lg w-full"
                  >
                    <label class="text-lg text-white"
                      >Question {{ index + 1 }}:</label
                    >
                    <button
                      v-if="form.id"
                      type="button"
                      class="bg-red-700 text-xs text-white rounded-md px-3 py-1"
                      @click="
                        (popupwindowquestiondelete = form.id),
                          (titlepass = form.question_text)
                      "
                    >
                      Remove Question
                    </button>

                    <button
                      v-else
                      type="button"
                      class="bg-red-700 text-xs text-white rounded-md px-3 py-1"
                      @click="removeFormUpdate(index)"
                    >
                      Remove Question
                    </button>
                  </div>

                  <div class="px-4 sm:px-6 py-2">
                    <textarea
                      v-model="form.question_text"
                      rows="2"
                      required
                      class="p-2 sm:p-4 md:p-4 rounded-md w-full text-sm sm:text-base"
                      placeholder="Enter your question"
                    >
                    </textarea>
                  </div>
                </div>

                <div class="flex items-center gap-2 px-4 sm:px-6 py-2">
                  <div>
                    <input
                      type="radio"
                      value="choice"
                      v-model="form.choice_type"
                    />
                    Choice Type
                  </div>
                  <!-- <div>
                    <input
                      type="radio"
                      value="coding"
                      v-model="form.choice_type"
                    />
                    Coding
                  </div> -->
                  <!-- <div>
                    <input
                      type="radio"
                      value="truefalse"
                      v-model="form.choice_type"
                    />
                    True or False
                  </div> -->
                  <!-- <div>
                    <input
                      type="radio"
                      value="matchthefollowing"
                      v-model="form.choice_type"
                    />
                    Match the following
                  </div> -->

                  <!-- <input
                    type="radio"
                    value="shortdescription"
                    v-model="form.choice_type"
                  />
                  Short Answer -->
                  <!-- <input
                    type="radio"
                    value="description"
                    v-model="form.choice_type"
                  />
                  Long Answer -->
                </div>

                <!-- {{ form.choiceType }} -->

                <div
                  v-if="form.choice_type == 'choice'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <div
                    v-for="(address, addrIndex) in form.answers"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    >
                    <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    />
                    <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    />
                    <label class="text-sm">Is Answer</label>

                    <!-- <button type="button" class="bg-red-500 rounded-lg rounded-lg text-white text-xs px-2 py-1" @click="removeChoiceTypeUpdate(addrIndex)">remove</button> -->
                  </div>

                  <button
                    type="button"
                    @click="addMoreChoiceTypeUpdate(index)"
                    class="bg-blues text-sm text-white rounded-md px-4 py-2"
                  >
                    Add More
                  </button>

                  <input
                    type="text"
                    required
                    v-model="form.max_mark"
                    maxlength="1"
                    @input="
                      form.max_mark = $event.target.value.replace(/[^1-9]/g, '')
                        ? Number($event.target.value.replace(/[^1-9]/g, ''))
                        : null
                    "
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter mark (1-9)"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'matchthefollowing'"
                  class="py-3 grid grid-cols-2 gap-2 mt-1 px-6"
                >
                  <div>
                    <div
                      v-for="(address, addrIndex) in form.matchthefollowing"
                      :key="addrIndex"
                      class="flex flex-wrap items-center gap-3 py-2"
                    >
                      <input
                        type="text"
                        v-model="address.left_text"
                        class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                        placeholder="Enter Left Option"
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <div
                      v-for="(address, addrIndex) in form.matchthefollowing"
                      :key="addrIndex"
                      class="flex flex-wrap items-center gap-3 py-2"
                    >
                      <input
                        type="text"
                        v-model="address.right_text"
                        class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                        placeholder="Enter Right Option"
                        required
                      />

                      <!-- <button class="bg-red-500 rounded-lg rounded-lg text-white text-xs px-2 py-1" @click="removeMatchtheFollowingUpdate(addrIndex)">remove</button> -->
                    </div>
                  </div>
                </div>

                <!-- <div v-if="form.choice_type == 'matchthefollowing'">
                    <button
                    type="button"
                    @click="addMoreMatchtheFollowingUpdate(index)"  
                    class="bg-blues text-sm text-white rounded-md px-4 py-2"
                  >
                    Add More
                  </button>
                </div> -->
                <div
                  v-if="form.choice_type == 'coding'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <label
                    for="language"
                    class="text-sm font-semibold text-gray-700"
                  >
                    Select Programming Language:
                  </label>
                  <select
                    id="language"
                    v-model="form.programming_language"
                    class="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option disabled value="">Select Language</option>
                    <option value="python">Python</option>
                    <!-- <option value="java">Java</option> -->
                    <option value="cpp">C++</option>
                    <option value="c">C</option>
                    <!-- <option value="javascript">JavaScript</option> -->
                  </select>
                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>
                <div
                  v-if="form.choice_type == 'truefalse'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <!-- {{ form.answers }} -->
                  <div
                    v-for="(address, addrIndex) in form.truefalse"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <!-- <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    > -->
                    <label class="text-sm text-gray-700"> </label>
                    <!-- <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    /> -->
                    <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    />
                    <!-- right_text -->
                    <!-- <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    /> -->
                    <label class="text-sm"
                      ><span v-if="addrIndex == 0">True</span>
                      <span v-else>False</span></label
                    >
                  </div>
                </div>

                <div
                  v-if="form.choice_type == 'shortdescription'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <textarea
                    rows="2"
                    v-model="form.shortAnswer.answer_text"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter your answer"
                    required
                  >
                  </textarea>
                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'description'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <textarea
                    rows="10"
                    v-model="form.longAnswer.answer_text"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter your answer"
                    required
                  >
                  </textarea>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    placeholder="Add Mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                  />
                </div>
              </div>
            </div>

            <div class="flex justify-end gap-4 mt-4">
              <button
                type="button"
                @click="addFormUpdateNew"
                class="bg-blues text-sm text-white rounded-md px-4 py-2"
              >
                Add Question
              </button>
            </div>

            <div class="flex justify-end items-center gap-3 pb-4 mt-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-10 py-2"
              >
                Update
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
class FileUpload {
  constructor(input) {
    this.input = input;
    this.max_length = 1024 * 1024 * 1024 * 100;
  }

  create_progress_bar() {
    var progress = `<div class="file-icon">
                            <i class="fa fa-file-o" aria-hidden="true"></i>
                        </div>
                        <div class="file-details">
                            <p class="filename"></p>
                            <small class="textbox"></small>
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                                </div>
                            </div>
                        </div>`;
    document.getElementById("uploaded_files").innerHTML = progress;
  }

  upload(append_id) {
    this.create_progress_bar();
    this.initFileUpload(append_id);
  }

  initFileUpload(append_id) {
    this.file = this.input.files[0];
    this.upload_file(0, null, append_id);
  }

  //upload file
  upload_file(start, model_id, append_id) {
    var end;
    var self = this;
    var existingPath = model_id;
    var formData = new FormData();
    var nextChunk = start + this.max_length + 1;
    var currentChunk = this.file.slice(start, nextChunk);
    var uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= this.file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("title", "title");

    formData.append("file", currentChunk);
    formData.append("filename", this.file.name);
    $(".filename").text(this.file.name);
    $(".textbox").text("Uploading file");
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);

    $.ajax({
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            if (self.file.size < self.max_length) {
              var percent = Math.round((e.loaded / e.total) * 100);
            } else {
              var percent = Math.round((uploadedChunk / self.file.size) * 100);
            }
            $(".progress-bar").css("width", percent + "%");
            $(".progress-bar").text(percent + "%");
          }
        });
        return xhr;
      },

      url: `${process.env.VUE_APP_API}/video-uploader/chunk/`,
      type: "POST",
      dataType: "json",
      cache: false,
      processData: false,
      contentType: false,
      data: formData,
      error: function (xhr) {
        alert(xhr.statusText);
        $(".filename").text("");
        $(".textbox").text("");
        // $(".progress-bar").css("width", percent + "%");
        $(".progress-bar").text("");
      },
      success: function (res) {
        if (nextChunk < self.file.size) {
          // upload file in chunks
          existingPath = res.existingPath;
          self.upload_file(nextChunk, existingPath);
          this.disable_update = false;
        } else {
          // upload complete
          $(".textbox").text(res.data);
          $(`#${append_id}`).val(res.existingPath);
          console.log(res, "resp::");
          this.disable_update = false;
          // alert(JSON.parse(res))
        }
      },
    });
  }
}

import axios from "axios";
import { mapGetters } from "vuex";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import FlashMessage from "@/components/FlashMessage.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";

import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

import { defineComponent } from "vue";
import { VueDraggableNext } from "vue-draggable-next";

export default {
  components: {
    QuillEditor,
    FlashMessage,
    ConfirmPopup,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
    Header,
    draggable: VueDraggableNext,
  },

  data() {
    return {
      contentType: "html",
      markdown: "# Hello",
      lessonInfo: "",
      lessonVal: {},
      TimeTableVal: "",
      TimeTablepopUp: false,
      popUp: false,
      popUpLesson: false,
      sectionInfo: "",
      popUpsection: false,
      sectionval: "",
      popUpsectionUpdate: false,
      messages: {
        text: "",
        type: "null",
      },
      uploadStatusMessage: "",
      popupsectionDelete: false,
      idpass: "",
      popuplessonDelete: false,
      titlepass: "",
      lesson_id: "",
      popupquiz: false,
      is_documentPopup: false,
      is_tablePopup: false,
      pageX: 0,
      pageY: 0,
      uploadDragoverTracking: false,
      uploadDragoverEvent: false,
      documentList: "",
      timeTable: "",
      timeTable_val: "",
      popupDocumentDelete: false,
      selectUnitId: null,
      activeOperationMenu: null,
      activeLessonOperationMenu: null,
      description: "",
      descriptionUpdate: "",
      takeTab: "add_lesson",
      forms: [
        {
          question_text: "",
          choice_type: "choice",
          programming_language: "",
          answers: [
            { answer_text: "", is_correct: false },
            { answer_text: "", is_correct: false },
            // { answer_text: "", is_correct: false },
            // { answer_text: "", is_correct: false },
          ],
          truefalse: [
            { answer_text: "True", is_correct: false },
            { answer_text: "False", is_correct: false },
          ],
          matchthefollowing: [
            { left_text: "", right_text: "" },
            { left_text: "", right_text: "" },
            // { left_text: "", right_text: "" },
            // { left_text: "", right_text: "" },
          ],
          shortAnswerMark: "",
          longAnswerMark: "",
          max_mark: "",
          // shortAnswer: "",
          // longAnswer: "",
        },
      ],
      choiceType: "choice",
      popUpQuiz: false,
      currentQuizData: "",
      popUpupdateQuiz: false,
      loaders: false,
      disable_submit: false,
      disable_update: false,
      popupwindowquestiondelete: null,
      loading: true,
      checkedPercentage: false,
      checkedAttempt: false,
      check_polls: false,
      check_locks: false,
      poll_choice: [
        {
          text: "",
        },
        {
          text: "",
        },
      ],
      polls_data: {
        question: "",
        options: [{ text: "" }, { text: "" }],
      },
      lock_data: "",
      video_error: "",
      pdf_error: "",
      audio_error: "",

      chunkSize: 1024 * 1024,
      chunkIndex: 0,
      totalChunks: 0,
      file: null,
      title: "Sample Video",
      // activeCourseMenu: null,
      activeCourseMenu: [],
      lessonloading: false,
      hidePercentage: false,
      hideattempt: false,
      publish: true,
      lessonType: "standard",
      uploadProgress: 0,
      uploadedBytes: 0,
      totalBytes: 0,
      isUploading: false,
      zipUrlNew: "",
      packageInfo: null,
      processing: false,
      processingMessage: "",
      pollTimer: null,
      indexFile: "",
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
    lessonsBySection() {
      if (!this.lessonInfo || !this.lessonInfo.results) return {};
      return this.lessonInfo.results.reduce((acc, lesson) => {
        if (!acc[lesson.section_id]) acc[lesson.section_id] = [];
        acc[lesson.section_id].push(lesson);
        return acc;
      }, {});
    },
    today() {
      return new Date().toISOString().split("T")[0];
    },
  },

  props: ["course_id"],

  async created() {
    this.lessoninfoGet();
    this.sectionInfoGet();
  },
  watch: {
    "lessonVal.locking_date"(val) {
      if (val) {
        this.lessonVal.locking_date = val.split("T")[0];
      }
    },
    "currentQuizData.persentage"(val) {
      if (val) {
        this.currentQuizData.question_attempt = false;
        this.currentQuizData.question_attempt_count = null;
        this.hideattempt = true;
      } else {
        this.hideattempt = false;
      }
    },

    "currentQuizData.question_attempt"(val) {
      if (val) {
        this.currentQuizData.persentage = false;
        this.currentQuizData.persentage_score = null;
        this.hidePercentage = true;
      } else {
        this.hidePercentage = false;
      }
    },
    lessonType(newValue) {
      if (newValue === "standard") {
        this.resetLessonForm();
      }
    },
  },

  mounted() {
    // setTimeout(()=>{
    //     document.getElementById("getVideoU").value = this.lessonVal.video_url;
    // },300)

    const script = document.createElement("script");
    script.src =
      "https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js";
    script.onload = () => {
      console.log("jQuery loaded");
      this.initJQuery();
    };
    document.head.appendChild(script);
    document.addEventListener("click", this.handleClickOutside);
    if (this.lessonVal.locking_status && this.lessonVal.locking_date) {
      this.lessonVal.locking_date = this.lessonVal.locking_date.split("T")[0];
    }
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    // courseSectionToggle(id) {
    //   this.activeCourseMenu = this.activeCourseMenu === id ? null : id;
    // },
    resetLessonForm() {
      if (this.$refs.lessonaddFnadd) {
        this.$refs.lessonaddFnadd.reset();
      }

      this.lessonType = "standard";
      this.description = "";
      this.lock_data = "";
      this.check_locks = false;
      this.check_polls = false;

      this.polls_data = {
        question: "",
        options: [{ text: "" }, { text: "" }],
      };

      this.zipUrlNew = "";
      this.indexFile = "";
      this.packageInfo = null;
      this.processing = false;
      this.processingMessage = "";
      this.uploadProgress = 0;
      this.isUploading = false;
      this.uploadStatusMessage = "";

      this.video_error = "";
      this.pdf_error = "";
      this.audio_error = "";
      this.disable_submit = false;
      this.disable_update = false;

      this.description = "";
      const editor = document.querySelector(".ql-editor");
      if (editor) {
        editor.innerHTML = "";
      }

      ["fileupload", "pdffile", "audio_file"].forEach((id) => {
        const input = document.getElementById(id);
        if (input) input.value = "";
      });
    },

    closeLessonResetModal() {
      this.resetLessonForm();
      this.lessonType = "standard";
      this.popUpLesson = false;
    },

    closeScormResetModal() {
      this.resetLessonForm();
      this.lessonType = "scorm";
      this.popUpLesson = false;
    },
    courseSectionToggle(id) {
      const index = this.activeCourseMenu.indexOf(id);

      if (index !== -1) {
        this.activeCourseMenu.splice(index, 1);
      } else {
        this.activeCourseMenu.push(id);
      }
    },
    // fileupload - file id
    // videoUrlNew - append url id
    getShortName(url) {
      if (!url) return "";
      const fileName = url.split("/").pop();

      if (fileName.length > 15) {
        return fileName.substring(0, 12) + "...";
      }
      return fileName;
    },

    removeAudio() {
      this.lessonVal.audio_file = "";
    },
    removePDF() {
      this.lessonVal.pdf_file = "";
    },
    uploadFilebyChunkNew(file_id, append_id) {
      const fileInput = document.getElementById(`${file_id}`);
      const file = fileInput.files[0];
      this.video_error = "";
      this.uploadStatusMessage = "";
      if (!file) {
        this.video_error = "Please select a file.";
        return;
      }
      this.file = file;
      this.totalChunks = Math.ceil(file.size / this.chunkSize);
      this.chunkIndex = 0;
      this.uploadedBytes = 0;
      this.totalBytes = this.file.size;
      this.uploadProgress = 0;
      this.isUploading = true;
      this.disable_update = true;
      this.sendChunk(append_id);
      console.log(append_id, "append_id::1");
    },

    sendChunk(append_id, retryCount = 0) {
      const start = this.chunkIndex * this.chunkSize;
      const end = Math.min(this.file.size, start + this.chunkSize);
      const chunk = this.file.slice(start, end);

      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("filename", this.file.name);
      formData.append("chunkIndex", this.chunkIndex);
      formData.append("totalChunks", this.totalChunks);
      formData.append("title", this.title);

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.VUE_APP_API}/video_uploader/chunk/`,
        true,
      );
      // xhr.setRequestHeader("X-CSRFToken", getCSRFToken());
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const currentUploaded = start + event.loaded;

          this.uploadProgress = Math.round(
            (currentUploaded / this.totalBytes) * 100,
          );
        }
      };
      xhr.onerror = () => {
        const maxRetries = 3;
        if (retryCount < maxRetries) {
          const delay = 3000;
          this.uploadStatusMessage = `Network issue detected. Retrying in ${
            delay / 1000
          }s... (Attempt ${retryCount + 1}/${maxRetries})`;
          setTimeout(() => {
            this.sendChunk(append_id, retryCount + 1);
          }, delay);
        } else {
          this.isUploading = false;
          this.disable_update = false;
          this.video_error =
            "Upload failed due to persistent network issues. Please check your connection and try again later.";
          this.uploadStatusMessage = "Upload failed due to network error.";
        }
      };
      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          this.uploadStatusMessage = response.message || "Uploading...";
          if (response.video_url) {
            const fullUrl = response.video_url;
            console.log(append_id, "append_id::1");

            const el = document.getElementById(append_id);
            if (el) {
               el.value = fullUrl;
               // explicitly fire an input event so Vue's v-model detects it!
               el.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }

          this.chunkIndex++;
          this.uploadedBytes = end;

          this.uploadProgress = Math.round(
            (this.uploadedBytes / this.totalBytes) * 100,
          );
          if (this.chunkIndex < this.totalChunks) {
            this.sendChunk(append_id, 0);
          } else {
            this.uploadProgress = 100;
            this.isUploading = false;
            this.disable_update = false;
            // alert("Upload complete!");
            this.uploadStatusMessage = "Upload complete!";
            setTimeout(() => {
              this.uploadStatusMessage = "";
            }, 3000);
            this.video_error = "";
          }
        } else if (xhr.status >= 500) {
          const maxRetries = 3;
          if (retryCount < maxRetries) {
            const delay = 3000;
            this.uploadStatusMessage = `Server issue detected. Retrying in ${
              delay / 1000
            }s... (Attempt ${retryCount + 1}/${maxRetries})`;
            setTimeout(() => {
              this.sendChunk(append_id, retryCount + 1);
            }, delay);
          } else {
            this.isUploading = false;
            this.disable_update = false;
            this.video_error = "Upload failed due to persistent server issues.";
            this.uploadStatusMessage = "Upload failed.";
          }
        } else {
          this.isUploading = false;
          this.disable_update = false;
          // alert("Upload failed: " + xhr.responseText);
          this.video_error = "Upload failed: " + xhr.responseText;
          this.uploadStatusMessage = "Upload failed.";
        }
      };

      xhr.send(formData);
    },
    uploadScormChunkNew(file_id, append_id) {
      const fileInput = document.getElementById(`${file_id}`);
      console.log("sdfgfsdgdf", fileInput);
      const file = fileInput.files[0];
      if (!file) {
        alert("Please select a file.");
        return;
      }
      // Reset states
      this.video_error = "";
      this.uploadStatusMessage = "";
      this.packageInfo = null;
      this.processing = false;
      this.processingMessage = "";

      this.file = file;
      this.totalChunks = Math.ceil(file.size / this.chunkSize);
      this.chunkIndex = 0;
      this.uploadedBytes = 0;
      this.totalBytes = this.file.size;
      this.uploadProgress = 0;
      this.isUploading = true;
      this.disable_update = true;
      this.sendScormChunk(append_id);
      console.log(append_id, "append_id::00000");
    },

    sendScormChunk(append_id) {
      const start = this.chunkIndex * this.chunkSize;
      const end = Math.min(this.file.size, start + this.chunkSize);
      const chunk = this.file.slice(start, end);

      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("filename", this.file.name);
      formData.append("chunkIndex", this.chunkIndex);
      formData.append("totalChunks", this.totalChunks);
      formData.append("title", this.title);

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.VUE_APP_API}/chunk-zip-file/upload/`,
        true,
      );
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const currentUploaded = start + event.loaded;

          this.uploadProgress = Math.round(
            (currentUploaded / this.totalBytes) * 100,
          );
        }
      };
      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          document.getElementById("statusCode").innerText = response.message;
          if (response.video_url) {
            this.zipUrlNew = response.video_url;

            // show processing
            this.processing = true;
            this.processingMessage = "Processing SCORM package...";

            this.fetchzip(response.object_id);
          }

          this.chunkIndex++;
          this.uploadedBytes = end;

          this.uploadProgress = Math.round(
            (this.uploadedBytes / this.totalBytes) * 100,
          );
          if (this.chunkIndex < this.totalChunks) {
            this.sendScormChunk(append_id);
          } else {
            this.uploadProgress = 100;
            this.isUploading = false;
            alert("Upload complete!");
          }
        } else {
          this.isUploading = false;
          this.disable_update = false;
          alert("Upload failed: " + xhr.responseText);
        }
      };
      xhr.onerror = () => {
        this.isUploading = false;
        this.disable_update = false;
        this.messages = {
          text: "Network error during upload. Please try again.",
          type: "error",
        };
      };
      xhr.send(formData);
    },
    fetchzip(id) {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
      }
      axios
        .get(
          `${process.env.VUE_APP_API}/course-package/deleted/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then(({ data }) => {
          const pkg = data.data;

          this.packageInfo = pkg;

          // keep polling
          if (
            pkg.progress_status !== "Completed" &&
            pkg.progress_status !== "Failed"
          ) {
            this.processing = true;
            this.processingMessage = pkg.progress_status || "Processing...";

            this.pollTimer = setTimeout(() => {
              this.fetchzip(id);
            }, 2000);

            return;
          }

          // success
          if (pkg.progress_status === "Completed") {
            clearTimeout(this.pollTimer);

            this.processing = false;
            this.isUploading = false;
            this.disable_update = false;
             this.disable_submit = false;
            this.processingMessage = "";

            this.indexFile = pkg.index_file;
            this.lessonVal.scrom_url = pkg.zip_file; // Original ZIP URL
            this.lessonVal.scrom_file = pkg.index_file; // Player URL

            console.log("SCORM URL:", this.lessonVal.scrom_url);
            console.log("Player URL:", this.lessonVal.scrom_file);

            setTimeout(() => {
              this.packageInfo = null;
            }, 5000);

            return;
          }

          // failed
          if (pkg.progress_status === "Failed") {
            clearTimeout(this.pollTimer);

            this.processing = false;
            this.isUploading = false;
            this.disable_update = false;
            // this.messages = {
            //   type: "error",
            //   text: pkg.description || "SCORM Package Processing Failed",
            // };
          }
        })
        .catch((error) => {
          console.error("Fetch package error:", error);
          this.processing = false;
          this.isUploading = false;
          this.disable_update = false;

          this.messages = {
            text: "Error checking package status. Please try again.",
            type: "error",
          };

          setTimeout(() => {
            this.messages = { text: "", type: "" };
          }, 5000);
        });
    },

    async videoUploadURLNewUrl() {
      console.log("Hellow..");
      // let urls = ``;

      let HeaderVal = {
        file: document.getElementById("fileupload").files[0],
      };

      await axios
        .post(
          `${process.env.VUE_APP_API}/api/chunked-upload/?Key=${this.userInfo.token_key}`,
          HeaderVal,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          console.log(response);
          // this.disable_submit = false;
          // console.log(response);
          // if (response.data.status == 200) {
          //   this.messages = {
          //     text: "Lesson added successfully",
          //     type: "success",
          //   };
          //   const fileInput = document.getElementById("fileupload");
          //   if (fileInput) {
          //     fileInput.value = null;
          //   }
          //   this.$refs.lessonaddFnadd.reset();
          //   this.popUpLesson = false;
          //   this.disable_submit = false;
          //   this.lessoninfoGet();
          //   this.polls_data = {
          //     question: "",
          //     options: [{ text: "" }, { text: "" }],
          //   };
          //   this.description = "";
          // } else {
          //   this.messages = {
          //     text: response.data.message,
          //     type: "error",
          //   };
          //   this.disable_submit = false;
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    removeChoiceTypeUpdate(index) {
      if (this.currentQuizData.questions[index].answers.length >= 3) {
        this.currentQuizData.questions[index].answers.splice(index, 1);
        // this.polls_data.splice(index, 1);
      } else {
        alert("Should 2 following on match the following.");
      }
    },

    addMoreChoiceTypeUpdate(index) {
      this.currentQuizData.questions[index].answers.push({
        answer_text: "",
        is_correct: false,
      });
    },

    removeChoiceType(index, addrIndex) {
      if (this.forms[index].answers.length >= 3) {
        this.forms[index].answers.splice(addrIndex, 1);
        // this.polls_data.splice(index, 1);
      } else {
        alert("Should 2 following on match the following.");
      }
    },

    addMoreChoiceType(index) {
      this.forms[index].answers.push({ answer_text: "", is_correct: false });
    },

    removeMatchtheFollowingUpdate(index) {
      // this.currentQuizData.questions[index].matchthefollowing.push({ left_text: "", right_text: "" })
      if (this.currentQuizData.questions[index].matchthefollowing.length >= 3) {
        this.currentQuizData.questions[index].matchthefollowing.splice(
          index,
          1,
        );
        // this.polls_data.splice(index, 1);
      } else {
        alert("Should 2 following on match the following.");
      }
    },

    addMoreMatchtheFollowingUpdate(index) {
      this.currentQuizData.questions[index].matchthefollowing.push({
        left_text: "",
        right_text: "",
      });
      // if(this.currentQuizData.questions[index].matchthefollowing.length >= 3){
      //   // this.currentQuizData.questions[index].matchthefollowing.splice(index, 1);
      //   // this.polls_data.splice(index, 1);
      // }
      // else{
      //   alert("Should 2 following on match the following.");
      // }
    },

    addMoreMatchtheFollowing(index) {
      this.forms[index].matchthefollowing.push({
        left_text: "",
        right_text: "",
      });
    },

    removeMatchtheFollowing(index) {
      if (this.forms[index].matchthefollowing.length >= 3) {
        this.forms[index].matchthefollowing.splice(index, 1);
        // this.polls_data.splice(index, 1);
      } else {
        alert("Should 2 following on match the following.");
      }
    },

    CheckAudioSizeUpload(event) {
      const file = event.target.files[0];
      const maxSize = 30 * 1024 * 1024;
      if (file.size > maxSize) {
        this.audio_error =
          "Audio file is larger than 30MB. Please choose a smaller file.";
        event.target.value = "";
        setTimeout(() => {
          this.audio_error = "";
        }, 5000);
      } else {
        this.audio_error = "";
      }
    },

    CheckPdfSizeUpload(event) {
      const file = event.target.files[0];
      const maxSize = 30 * 1024 * 1024;
      if (file.size > maxSize) {
        this.pdf_error =
          "Pdf file is larger than 30MB. Please choose a smaller file.";
        event.target.value = "";
        setTimeout(() => {
          this.pdf_error = "";
        }, 5000);
      } else {
        this.pdf_error = "";
      }
    },

    CheckVideoSizeUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.video_error = "";

      const allowedExtensions = [
        "mp4",
        "avi",
        "mov",
        "mkv",
        "wmv",
        "webm",
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "zip",
      ];

      const extension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        this.video_error =
          "Invalid file format. Only Video, PDF, DOC, DOCX, XLS, XLSX and ZIP files are allowed.";
        event.target.value = "";
        setTimeout(() => {
          this.video_error = "";
        }, 3000);
        return;
      }

      this.video_error = "";
      this.file = file;
    },
    havePercentage(id) {
      if (document.getElementById(id).checked) {
        this.checkedPercentage = true;
        this.hideattempt = true;
      } else {
        this.checkedPercentage = false;
        this.hideattempt = false;
      }
    },

    haveAttempt(id) {
      if (document.getElementById(id).checked) {
        this.checkedAttempt = true;
        this.hidePercentage = true;
      } else {
        this.checkedAttempt = false;
        this.hidePercentage = false;
      }
    },

    // enable polls
    havePolls(id) {
      if (document.getElementById(id).checked) {
        this.check_polls = true;
      } else {
        this.check_polls = false;
      }
    },
    haveLocks(id) {
      if (document.getElementById(id).checked) {
        this.check_locks = true;
      } else {
        this.check_locks = false;
      }
    },
    addRow() {
      this.polls_data.options.push({ text: "" });
    },
    removeRow(index) {
      if (this.polls_data.options.length > 2) {
        this.polls_data.options.splice(index, 1);
      }
    },
    // edit options in lesson
    editAddRow(poll) {
      console.log("poll", poll.length);
      return poll.push({ text: "", id: poll.length + 1, count: 0 });
    },
    editRemoveRow(poll, index) {
      console.log("poll", poll);
      if (poll.length > 1) {
        poll.splice(index, 1);
      }
    },
    updatePolls() {},
    removeQuestion(id) {
      axios
        .delete(
          `${process.env.VUE_APP_API}/coursequiz/question/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            // this.generalquiz = [];
            this.messages = {
              text: "Quiz Deleted successfully",
              type: "success",
            };
            // this.quizgetinfo();
            // this.popupwindow = false;
            this.lessoninfoGet();
            this.popUpupdateQuiz = false;
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            // this.$router.go(0);
            this.popupwindowquestiondelete = null;
            this.messages = {
              text: " ",
              type: "null",
            };
          }, 2000);
        });
    },

    validateChoiceQuestions(questions) {
      if (!questions || questions.length === 0) return true;
      for (let i = 0; i < questions.length; i++) {
        let q = questions[i];
        if (q.choice_type === 'choice' && q.answers) {
          let hasCorrect = q.answers.some(a => a.is_correct === true || a.is_correct === 'true' || a.is_correct === 1);
          if (!hasCorrect) {
            this.messages = {
              text: `Please select at least one correct answer for Question ${i + 1}.`,
              type: "error",
            };
            setTimeout(() => {
              this.messages = { text: "", type: "" };
            }, 3000);
            return false;
          }
        }
      }
      return true;
    },

    // this.currentQuizData.questions.forEach((element) => {})

    updateQuizOfSection(value_id) {
      if (!this.validateChoiceQuestions(this.currentQuizData?.questions)) {
        return;
      }

      this.disable_submit = true;
      if (this.currentQuizData.question_attempt == false) {
        this.currentQuizData.question_attempt_count = null;
      }
      if (this.currentQuizData.persentage == false) {
        this.currentQuizData.persentage_score = null;
      }

      console.log("this.currentQuizData", this.currentQuizData);
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${value_id}/?Key=${this.userInfo.token_key}`,
          this.currentQuizData,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == "200") {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.lessoninfoGet();
              this.popUpupdateQuiz = false;
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          } else {
            // console.log("something went wrong");
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.lessoninfoGet();
              // this.popUpupdateQuiz = false;
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    getupdateValues(value_id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${value_id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            const data = response.data.data;

            if (!data.question_attempt) {
              data.question_attempt_count = null;
            }
            if (!data.persentage) {
              data.persentage_score = null;
            }

            this.currentQuizData = data;
            this.hideattempt = data.persentage ? true : false;
            this.hidePercentage = data.question_attempt ? true : false;
          }
        });
    },

    // updateVale(value) {
    //   setTimeout(() => {
    //     document.getElementById("getVideoU").value = value.video_url;
    //   }, 50);
    // },
    updateVale(value) {
      // Store the lesson data
      if (value) {
        this.lessonVal = { ...value };

        // Wait for DOM to render
        this.$nextTick(() => {
          // If it's a SCORM lesson, set the scrom_url and scrom_file
          if (value.scrom_file) {
            this.lessonVal.scrom_url = value.scrom_url || "";
            this.lessonVal.scrom_file = value.scrom_file || "";
          }
        });
      }
    },
    triggerAddUNitClose() {
      this.$emit("close-AddUnit");
    },

    addForm() {
      this.forms.push({
        question_text: "",
        choice_type: "choice",
        answers: [
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          // { answer_text: "", is_correct: false },
          // { answer_text: "", is_correct: false },
        ],
        truefalse: [
          { answer_text: "True", is_correct: false },
          { answer_text: "False", is_correct: false },
        ],
        matchthefollowing: [
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          // { left_text: "", right_text: "" },
          // { left_text: "", right_text: "" },
        ],
        shortAnswer: "",
        longAnswer: "",
        max_mark: "",
        // shortAnswerMark: "",
        // longAnswerMark:"",
      });
    },

    addFormUpdateNew() {
      this.currentQuizData.questions.push({
        question_text: "",
        choice_type: "choice",
        answers: [
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          // { answer_text: "", is_correct: false },
          // { answer_text: "", is_correct: false },
        ],
        truefalse: [
          { answer_text: "True", is_correct: false },
          { answer_text: "False", is_correct: false },
        ],
        matchthefollowing: [
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          // { left_text: "", right_text: "" },
          // { left_text: "", right_text: "" },
        ],
        shortAnswer: "",
        longAnswer: "",
        max_mark: "",
        // shortAnswerMark: "",
        // longAnswerMark:"",
      });
    },

    removeForm(index) {
      if (this.forms.length > 1) {
        this.forms.splice(index, 1);
      } else {
        alert("At least one form must be present!");
      }
    },

    removeFormUpdate(index) {
      this.currentQuizData.questions.splice(index, 1);
      // if (this.forms.length > 1) {
      //   this.forms.splice(index, 1);
      // } else {
      //   alert("At least one form must be present!");
      // }
    },

    convertToEmbed(id) {
      // console.log("video embed convert:::");
      let urlsBody = document.getElementById(id);
      let urls = document.getElementById(id).value;

      const videoId = this.extractVideoId(urls);

      if (videoId != null) {
        // this.embedLink = `https://www.youtube.com/embed/${videoId}`;
        // return `https://www.youtube.com/embed/${videoId}`
        urlsBody.value = `${videoId}`;
      } else {
        urlsBody.value = urls;
        // alert('Invalid YouTube URL');
      }
    },

    extractVideoId(url) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11
        ? `https://www.youtube.com/embed/${match[2]}`
        : null;

      // return (match && match[2].length === 11)
      // ? match[2]
      // : null;
    },

    videoUploadURL() {
      // this.disable_update = true;
      var uploader = new FileUpload(document.querySelector("#fileupload"));
      console.log(document.querySelector("#fileupload"));
      uploader.upload("videoUrl");
    },
    // videoUploadURL() {
    //   const lesson_vid = document.querySelector("#fileupload");
    //   const file = lesson_vid.files[0];

    //   if (!file) {
    //     console.error("No file selected");
    //     return;
    //   }

    //   const formData = new FormData();
    //   formData.append("file", file);

    //   axios
    //     .post(
    //       `${process.env.VUE_APP_API}/video_uploader/chunk/?Key=${this.userInfo.token_key}`,
    //       formData,
    //       {
    //         headers: {
    //           "Content-Type": "multipart/form-data",
    //         },
    //       }
    //     )
    //     .then((resp) => {
    //       console.log("Upload response:", resp);
    //     })
    //     .catch((err) => {
    //       console.error("Upload error:", err.response?.data || err.message);
    //     });
    // },

    videoUploadURLUpdate() {
      // fileuploadUpdate
      var uploader = new FileUpload(
        document.querySelector("#fileuploadUpdate"),
      );
      console.log(document.querySelector("#fileuploadUpdate"));
      uploader.upload("getVideoU");
    },

    initJQuery() {
      $(document).ready(() => {
        console.log("jQuery is ready in this component");
      });
    },

    addLessonOperation(id) {
      this.activeOperationMenu = null;
      if (this.activeLessonOperationMenu == id) {
        this.activeLessonOperationMenu = null;
      } else {
        this.activeLessonOperationMenu = id;
      }
    },
    addOperation(id) {
      this.activeLessonOperationMenu = null;
      if (this.activeOperationMenu == id) {
        this.activeOperationMenu = null;
      } else {
        this.activeOperationMenu = id;
      }
    },

    async lessoninfoGet() {
      this.lessonloading = true;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/lessons/?course_name=${this.course_id}&Key=${this.userInfo.token_key}`,
        );

        if (Object.keys(response.data) == "error") {
          this.lessonInfo = null;
        } else {
          this.lessonInfo = response.data;
        }
      } finally {
        this.lessonloading = false;
      }
    },

    async sectionInfoGet() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/section/?course_name=${this.course_id}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.status == 200) {
            this.sectionInfo = response.data;
            // if (this.sectionInfo.data.length > 0) {
            //   this.activeCourseMenu = this.sectionInfo.data[0].id;
            // }
            if (this.sectionInfo.data.length > 0) {
              this.activeCourseMenu = [this.sectionInfo.data[0].id];
            }

            this.loading = false;
          } else {
            console.log("catch error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

  async updateLesson(el) {
  this.disable_submit = true;

  const url = `${process.env.VUE_APP_API}/lessonupdate/${this.lessonVal.id}/?Key=${this.userInfo.token_key}`;

  try {
    const formData = new FormData();
    formData.append("id", this.lessonVal.id);
    formData.append("title", this.lessonVal.title || "");
    formData.append("feedback", this.lessonVal.feedback ?? false);
    formData.append(
      "locking_status",
      this.lessonVal.locking_status ?? false
    );
    formData.append("orderby", this.lessonVal.orderby || "");
    formData.append("file_type", this.lessonVal.file_type || "");
    formData.append("status", this.lessonVal.status ?? true);

    if (this.lessonVal.locking_status && this.lessonVal.locking_date) {
      formData.append("locking_date", this.lessonVal.locking_date);
    }

    if (this.lessonVal.scrom_file) {
      formData.append("scrom_url", this.lessonVal.scrom_url || "");

      if (this.lessonVal.scrom_file instanceof File) {
        formData.append("scrom_file", this.lessonVal.scrom_file);
      }
    }

    else {
      this.descriptionUpdate =
        document.querySelector(".ql-editor")?.innerHTML || "";

      formData.append("duration", this.lessonVal.duration || "");
      formData.append("video_url", this.lessonVal.video_url || "");
      formData.append("created_at", this.lessonVal.created_at || "");
      formData.append("updated_at", new Date().toISOString());
      formData.append("content", this.descriptionUpdate);
      formData.append("keyworeds", this.lessonVal.keyworeds || "");
      formData.append("slug", this.lessonVal.slug || "");
      formData.append("section_id", this.lessonVal.section_id || "");
      formData.append("course_name", this.lessonVal.course_name || "");
      formData.append(
        "show_polls",
        this.lessonVal.show_polls ?? false
      );

      formData.append(
        "polls",
        this.lessonVal.polls ?? false
      );


      let pollDetails = null;

      if (
        this.lessonVal.poll_details &&
        typeof this.lessonVal.poll_details === "object"
      ) {
        pollDetails = {
          poll_id:
            this.lessonVal.poll_details.poll_id ||
            this.lessonVal.poll_details.id ||
            null,

          question:
            this.lessonVal.poll_details.question || "",

          options: Array.isArray(
            this.lessonVal.poll_details.options
          )
            ? this.lessonVal.poll_details.options
            : [],
        };
      } else if (
        this.polls_data &&
        typeof this.polls_data === "object"
      ) {
        pollDetails = {
          poll_id:
            this.polls_data.poll_id ||
            this.polls_data.id ||
            null,

          question:
            this.polls_data.question || "",

          options: Array.isArray(this.polls_data.options)
            ? this.polls_data.options
            : [],
        };
      }

      if (pollDetails) {
        formData.append(
          "poll_details",
          JSON.stringify(pollDetails)
        );
      }

      const audioFile =
        el.target.elements.audiofile?.files?.[0];

      const pdfFile =
        el.target.elements.pdf_files?.files?.[0];

      if (audioFile) {
        formData.append("audio_file", audioFile);
      }

      if (pdfFile) {
        formData.append("pdf_file", pdfFile);
      }
    }



    const response = await axios.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });


    if (
      response.data.message ===
      "lesson updated successfully"
    ) {
      this.messages = {
        text: "Lesson updated successfully",
        type: "success",
      };


this.popUp = false;
      this.$refs.lessonaddFn.reset();

      setTimeout(() => {
           const fileInput =
        document.getElementById("fileuploadUpdate");

      if (fileInput) {
        fileInput.value = null;
      }



        this.messages = {
          text: "",
          type: "",
        };
      }, 2000);
      await this.lessoninfoGet();
    } else {
      this.messages = {
        text: "Lesson update failed",
        type: "error",
      };

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "",
        };
      }, 2000);
    }
  } catch (error) {
    console.error("Lesson Update Error:", error);

    if (error.response) {
      console.error(
        "API Status:",
        error.response.status
      );

      console.error(
        "API Error:",
        error.response.data
      );
    }

    this.messages = {
      text: "Something went wrong",
      type: "error",
    };

    setTimeout(() => {
      this.messages = {
        text: "",
        type: "",
      };
    }, 2000);
  } finally {
    this.disable_submit = false;
  }
},
    async createNewLesson(el) {
      this.disable_submit = true;
      const urls = `${process.env.VUE_APP_API}/lessonsnew/?Key=${this.userInfo.token_key}`;
      const HeaderVal = new FormData(); // <-- Declare here only once
      const couseId = this.course_id;
      if (this.lessonType === "standard") {
        this.description = document.querySelector(".ql-editor").innerHTML;

        let file_val = el.target.elements.pdffile.files;
        let audio_file = el.target.elements.audio_file.files;
        if (file_val.length > 0) {
          HeaderVal.append("pdf_file", el.target.elements.pdffile.files[0]);
        }
        if (audio_file.length > 0) {
          HeaderVal.append(
            "audio_file",
            el.target.elements.audio_file.files[0],
          );
        }
        HeaderVal.append("title", el.target.elements.title.value);
        HeaderVal.append("duration", el.target.elements.duration.value);
        HeaderVal.append("video_url", el.target.elements.videoUrlNew.value);
        HeaderVal.append("status", true);
        HeaderVal.append("content", this.description);
        HeaderVal.append("keyworeds", el.target.elements.keywords.value);
        HeaderVal.append("section_id", this.selectUnitId);
        HeaderVal.append("course_name", couseId);
        HeaderVal.append("orderby", el.target.elements.orderby.value);
        HeaderVal.append("file_type", el.target.elements.icon.value);
        HeaderVal.append("lesson_or_quiz", "lesson");
        HeaderVal.append("show_polls", el.target.elements.show_polls.checked);
        HeaderVal.append("polls", el.target.elements.poll_attempt.checked);
        HeaderVal.append("polls_data", JSON.stringify(this.polls_data));
        HeaderVal.append("feedback", el.target.elements.feedback.checked);
        console.log("HeaderVal", HeaderVal);
        // show_polls
        // lesson_or_quiz
        // HeaderVal.append("showing_timer", el.target.elements.showing_timer.value);

        // HeaderVal.append("quizzes", 2);
        HeaderVal.append("locking_date", this.lock_data);
        HeaderVal.append(
          "locking_status",
          el.target.elements.lock_attempt.checked,
        );
      } else if (this.lessonType === "scorm") {
        HeaderVal.append("title", el.target.elements.title.value);
        HeaderVal.append("section_id", this.selectUnitId);
        HeaderVal.append("course_name", couseId);
        HeaderVal.append("file_type", el.target.elements.icon.value);
        HeaderVal.append("orderby", el.target.elements.orderby.value);
        HeaderVal.append("feedback", el.target.elements.feedback.checked);
        HeaderVal.append("lesson_or_quiz", "lesson");
        HeaderVal.append("locking_date", this.lock_data);
        HeaderVal.append(
          "locking_status",
          el.target.elements.lock_attempt.checked,
        );
        HeaderVal.append("status", true);
        HeaderVal.append("scrom_url", this.zipUrlNew);
        HeaderVal.append("scrom_file", this.indexFile);
      }

      await axios
        .post(urls, HeaderVal, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.disable_submit = false;
          console.log(response);
          if (response.data.status == 200) {
            this.messages = {
              text: "Lesson added successfully",
              type: "success",
            };
            const fileInput = document.getElementById("fileupload");
            if (fileInput) {
              fileInput.value = null;
            }
            this.$refs.lessonaddFnadd.reset();
            this.popUpLesson = false;
            this.disable_submit = false;
            this.lessoninfoGet();
            this.polls_data = {
              question: "",
              options: [{ text: "" }, { text: "" }],
            };
            this.description = "";
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            this.disable_submit = false;
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },

    async createQuizOfSection(el) {
      if (!this.validateChoiceQuestions(this.forms)) {
        return;
      }

      this.disable_submit = true;
      // this.description = document.querySelector(".ql-editor").innerHTML;
      // console.log(this.description);

      let urls = `${process.env.VUE_APP_API}/lessonsnew/?Key=${this.userInfo.token_key}`;

      let HeaderVal = {};
      let couseId = this.course_id;

      HeaderVal["title"] = el.target.elements.title.value;
      HeaderVal["content"] = el.target.elements.content.value;
      HeaderVal["section_id"] = this.selectUnitId;
      HeaderVal["course_name"] = parseInt(couseId);
      HeaderVal["orderby"] = el.target.elements.order.value;
      HeaderVal["lesson_or_quiz"] = "quiz";
      HeaderVal["status"] = true;

      let quizData = {};
      quizData["user"] = this.userInfo.user.id;
      quizData["course"] = parseInt(couseId);
      quizData["name"] = el.target.elements.title.value;
      quizData["description"] = "description";
      quizData["timer"] = el.target.elements.duration.value;

      quizData["total_score"] = 100;
      quizData["qualify_certificate"] = true;
      quizData["min_score"] = 50;
      quizData["pre_quiz"] = false;

      quizData["quizsfeedback"] = el.target.elements.feedback.checked;

      if (this.checkedAttempt) {
        quizData["question_attempt"] =
          el.target.elements.question_attempt.checked;
        quizData["question_attempt_count"] = parseInt(
          el.target.elements.question_attempt_count.value,
        );
      }
      if (this.checkedPercentage) {
        quizData["persentage"] = el.target.elements.Percentage.checked;
        quizData["persentage_score"] = parseInt(
          el.target.elements.Percentage_count.value,
        );
      }
      console.log("checkedPercentage////", this.checkedPercentage);

      quizData["questions"] = this.forms;
      HeaderVal["quiz"] = quizData;

      await axios.post(urls, HeaderVal).then((response) => {
        console.log(response);
        this.disable_submit = false;

        if (response.data.status == 200) {
          this.messages = {
            text: "Quiz added successfully",
            type: "success",
          };
          this.$refs.addQuizRefs.reset();
          this.popUpQuiz = false;
          this.disable_submit = false;
          this.lessoninfoGet();
          this.checkedAttempt = false;
          this.checkedPercentage = false;
          this.hidePercentage = false;
          this.hideAttempt = false;
          this.forms = [
            {
              question_text: "",
              choice_type: "choice",
              answers: [
                { answer_text: "", is_correct: false },
                { answer_text: "", is_correct: false },
                // { answer_text: "", is_correct: false },
                // { answer_text: "", is_correct: false },
              ],
              truefalse: [
                { answer_text: "True", is_correct: false },
                { answer_text: "False", is_correct: false },
              ],
              matchthefollowing: [
                { left_text: "", right_text: "" },
                { left_text: "", right_text: "" },
                // { left_text: "", right_text: "" },
                // { left_text: "", right_text: "" },
              ],
              shortAnswerMark: "",
              longAnswerMark: "",
              max_mark: "",
            },
          ];
        } else {
          this.messages = {
            text: response.data.message,
            type: "error",
          };
          this.disable_submit = false;
        }
      });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },

    async createNewsection(el) {
      this.disable_submit = true;
      let newsection = {
        duration: el.target.elements.duration.value,
        // rbt_levels: el.target.elements.rbt_levels.value,
        title: el.target.elements.title.value,
        course_id: this.course_id,
        file_type: el.target.elements.icon.value,
        orderby: Number(el.target.elements.ordering.value),
        feedback: el.target.elements.feedback.checked,
        locking_status: el.target.elements.module_lock.checked,
        is_publish: this.publish ? "true" : "false",
      };
      await axios
        .post(
          `${process.env.VUE_APP_API}/sectionnew/?Key=${this.userInfo.token_key}`,
          newsection,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Section added successfully",
              type: "success",
            };
            this.$refs.addSection.reset();
            this.popUpsection = false;
            this.disable_submit = false;
            this.sectionInfoGet();
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
            this.disable_submit = false;
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
      // setTimeout(()=>{this.$router.go(0);},1000)
    },
    updatesection(data) {
      this.disable_submit = true;
      this.popUpsectionUpdate = false;

      let updatedsection = {
        id: data.id,
        title: data.title,
        course_name: data.course_name,
        file_type: data.file_type,
        orderby: data.orderby,
        feedback: data.feedback,
        locking_status: data.locking_status,
        is_publish: this.sectionval.is_publish ? "true" : "false",
      };
      console.log("updatedsection", updatedsection);

      axios
        .put(
          `${process.env.VUE_APP_API}/Sectionupdate/${data.id}/?Key=${this.userInfo.token_key}`,
          updatedsection,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "section updated successfully",
              type: "success",
            };
            this.sectionInfoGet();
            this.disable_submit = false;
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
            this.disable_submit = false;
          }
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },
    async deleteLesson(lessonVal) {
      this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/lesson_deleted/${lessonVal}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          this.disable_submit = false;
          //  setTimeout(()=>{this.$router.go(0);},1000)
          if (response.data.status == 200) {
            this.checkedAttempt = false;
            this.checkedPercentage = false;
            this.messages = {
              text: "lesson Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);

      this.popuplessonDelete = false;
      await this.lessoninfoGet();
    },
    async deleteSection(section) {
      this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/section_deleted/${section}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Section Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);

      this.popupsectionDelete = false;
      await this.sectionInfoGet();
      //  setTimeout(()=>{this.$router.go(0);},1000)
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.activeOperationMenu = null;
        this.activeLessonOperationMenu = null;
      }
    },
    // async onReorder(event) {
    //   console.log("Reorder event:", event);

    //   const token_key = this.userInfo.token_key;

    //   this.lessonInfo.results.forEach((lesson, index) => {
    //     lesson.orderby = index + 1;
    //   });

    //   console.log("Updated lessonInfo results:", this.lessonInfo.results);

    //   for (let lesson of this.lessonInfo.results) {
    //     const infoDetails = {
    //       orderby: lesson.orderby,
    //     };

    //     try {
    //       const response = await axios.put(
    //         `${process.env.VUE_APP_API}/lesson-order-id-updated/${lesson.id}/?Key=${token_key}`,
    //         infoDetails
    //       );

    //       console.log(`Response for lesson ${lesson.id}:`, response.data);

    //       if (response.data.message === "lesson updated successfully") {
    //         console.log(`Lesson ${lesson.id} reordered successfully`);
    //       } else {
    //         console.warn(`Lesson ${lesson.id} reorder failed`);
    //       }
    //     } catch (err) {
    //       console.error(`Error updating lesson ${lesson.id}:`, err);
    //     }
    //   }

    //   this.messages = {
    //     text: "Lesson order updated",
    //     type: "success",
    //   };

    //   setTimeout(() => {
    //     this.messages = { text: "", type: "" };
    //   }, 2000);
    // },
    async onReorder(sectionId, evt) {
      console.log("Drag change:", evt, "Target Section:", sectionId);

      const token_key = this.userInfo.token_key;

      // When lesson is added to a new section
      if (evt.added) {
        const movedLesson = evt.added.element;
        movedLesson.section_id = sectionId; // update section
        console.log(`Lesson ${movedLesson.id} moved to section ${sectionId}`);
      }

      // Get all lessons in this section
      const lessons = this.lessonsBySection[sectionId] || [];

      // Reassign order numbers
      lessons.forEach((lesson, index) => {
        lesson.orderby = index + 1;
      });

      // Push updates to API
      for (let lesson of lessons) {
        const infoDetails = {
          orderby: lesson.orderby,
          section_id: lesson.section_id,
        };

        try {
          const response = await axios.put(
            `${process.env.VUE_APP_API}/lesson-unit-order-id-updated/${lesson.id}/?Key=${token_key}`,
            infoDetails,
          );
          console.log(`Updated lesson ${lesson.id}:`, response.data);
        } catch (err) {
          console.error(`Error updating lesson ${lesson.id}:`, err);
        }
      }

      this.messages = { text: "Lesson order updated", type: "success" };
      setTimeout(() => {
        this.messages = { text: "", type: "" };
      }, 2000);
    },
    async onSecReorder(event) {
      console.log("Reorder event:", event);

      const token_key = this.userInfo.token_key;

      this.sectionInfo.data.forEach((section, index) => {
        section.orderby = index + 1;
      });

      console.log("Updated lessonInfo results:", this.sectionInfo.data);

      for (let section of this.sectionInfo.data) {
        const infoDetails = {
          id: section.id,
          title: section.title,
          course_name: section.course_name,
          file_type: section.file_type,
          orderby: section.orderby,
        };

        try {
          const response = await axios.put(
            `${process.env.VUE_APP_API}/Sectionupdate/${section.id}/?Key=${token_key}`,
            infoDetails,
          );

          console.log(`Response for section ${section.id}:`, response.data);

          if (response.data.message === "Section updated successfully") {
            console.log(`Section ${section.id} reordered successfully`);
          } else {
            console.warn(`Section ${section.id} reorder failed`);
          }
        } catch (err) {
          console.error(`Error updating Section ${section.id}:`, err);
        }
      }

      this.messages = {
        text: "Section order updated",
        type: "success",
      };

      setTimeout(() => {
        this.messages = { text: "", type: "" };
      }, 2000);
    },
    closepoup() {
      this.popUpQuiz = false;
      this.checkedPercentage = false;
      this.checkedAttempt = false;
      this.hideattempt = false;
      this.hidePercentage = false;
      document.getElementById("feedback").checked = false;
      this.$refs.addQuizRefs.reset();
      this.forms = [
        {
          question_text: "",
          choice_type: "choice",
          answers: [
            { answer_text: "", is_correct: false },
            { answer_text: "", is_correct: false },
          ],
          truefalse: [
            { answer_text: "True", is_correct: false },
            { answer_text: "False", is_correct: false },
          ],
          matchthefollowing: [
            { left_text: "", right_text: "" },
            { left_text: "", right_text: "" },
          ],
          shortAnswerMark: "",
          longAnswerMark: "",
          max_mark: "",
        },
      ];
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

/* loader  */
.spinner {
  --d: 8.6px;
  width: 1.5px;
  height: 1.5px;
  border-radius: 50%;
  color: #ada7a7;
  box-shadow: calc(1 * var(--d)) calc(0 * var(--d)) 0 0,
    calc(0.707 * var(--d)) calc(0.707 * var(--d)) 0 0.5px,
    calc(0 * var(--d)) calc(1 * var(--d)) 0 1px,
    calc(-0.707 * var(--d)) calc(0.707 * var(--d)) 0 1.4px,
    calc(-1 * var(--d)) calc(0 * var(--d)) 0 1.9px,
    calc(-0.707 * var(--d)) calc(-0.707 * var(--d)) 0 2.4px,
    calc(0 * var(--d)) calc(-1 * var(--d)) 0 2.9px;
  animation: spinner-a90wxe 1s infinite steps(8);
}

@keyframes spinner-a90wxe {
  100% {
    transform: rotate(1turn);
  }
}
</style>
